/* WavePlayer v 1.1.0
*
* Player class for HTML5 player on WavePost
* Copyright 2017 WavePost Inc
*
* Supports fullscreen playback, drawing and point-based comments
* slow-mo, fast forward, looping, and playback quality selection
*
*
*/

import $ from 'jquery';
import * as THREE from 'three';
import { toast } from '../../store/StoreUtil';
import t from '../../i18n/I18n';

$.fn.wavePlayer = function(options) {
  /* options available to user */
  this.playerSettings = $.extend(
    {
      width: 1920,
      height: 1080,
      ratio: 16 / 9,
      framerate: 29.97,
      startTime: 0,
      duration: 0,
      volume: 1,
      playbackSpeed: 1,
      loop: false,
      playlist: {},
      quality: 'HD',
      isVR: false,
      vrMode: 'none',
      autostart: true,
      pressNextButtonOnEnd: false,
      alwaysShowControls: false,
      showTitleSafe: false,
      enableComments: false,
      commentsClickFallback: null,
      playbackErrorStr: t('VIDEO_PLAYER.PLAYBACK_ERROR'),
      keyMsgStr: t('VIDEO_PLAYER.KEY_MSG_FOR_PLAYER'),
      commentMsgStr: t('VIDEO_PLAYER.COMMENT_MSG_STR')
    },
    options
  );

  this.playerSettings.playlist = $.extend(
    {
      mp4: '',
      webm: '',
      mobile_mp4: '',
      mp3: '',
      waveform: '',
      poster: ''
    },
    this.playerSettings.playlist
  );

  /* internal settings */
  this.config = {};
  this.config = $.extend(
    {
      videoObject: null,
      isAudio: false,
      maxSpeed: 4,
      maxSlow: 0.25,
      maxBackwards: -4,
      animationLength: 250,
      userAgent: '',
      userAgentVersion: 0,
      isFullscreen: false,
      isSeeking: false,
      crossOrigin: 'use-credentials',
      VR_VIEW_FLAT: 'flat',
      VR_VIEW_SPHERICAL: 'spherical',
      VR_VIEW_LEFT_SPHERICAL: 'left_spherical',
      VR_VIEW_RIGHT_SPHERICAL: 'right_spherical',
      VR_MODE_NONE: 'none',
      VR_MODE_MONOSCOPIC: 'monoscopic',
      VR_MODE_OVERUNDER: 'overunder',
      VR_MODE_SIDEBYSIDE: 'sidebyside',
      curVRView: 'none',
      enableVR: true,
      curLat: 0,
      curLon: 0,
      fov: 35,
      fovMin: 3,
      fovMax: 100,
      flatProjection: false,
      threeJSObj: {},
      videoCanvasHeight: 450,
      audioCanvasHeight: 200,
      vrCanvasWidth: 1920,
      vrCanvasHeight: 1080,
      vrVideoWidth: 1920,
      vrVideoHeight: 1080,
      vrCameraAnimationLength: 1000,
      comments: [],
      curComment: null,
      commentsVisible: false,
      /*  commentColorOptions: ["#e64d3d", "#e6943d", "#e6d83d", "#51e63d", "#3dd8e6", "#3d7de6", "#a83de6" ], */
      commentColorOptions: ['#ff2424', '#ff9c27', '#ffff00', '#00ff00', '#00ffff', '#0072ff', '#ff00ff'],
      commentColor: 0,
      enableFullscreen:
        typeof document.requestFullScreen == 'function' ||
        typeof document.requestFullscreen == 'function' ||
        typeof document.webkitRequestFullscreen == 'function' ||
        typeof document.webkitRequestFullScreen == 'function' ||
        typeof document.mozRequestFullScreen == 'function' ||
        typeof document.msRequestFullscreen == 'function',
      isTouch:
        'ontouchstart' in window ||
        navigator.userAgent.match(/Windows Phone/i) ||
        navigator.userAgent.match(/IEMobile/i),
      isiOS: navigator.userAgent.match(/(iPhone|iPod|iPad)/gi),
      isiPad: navigator.userAgent.match(/(iPad)/gi),
      isIE: false,
      isIEMobile: navigator.userAgent.match(/Windows Phone/i) || navigator.userAgent.match(/IEMobile/i)
    },
    this.config
  );

  var obj = this;
  var videoPlayer, key_message;
  var isDraggingTimePosition = false,
    timeOfDragStart = 0,
    timeOfLastDragUpdate = 0,
    dragUpdateInterval = 100,
    dragRefreshTimeout;
  var mouseOverTimeout, progressMouseoverTimeout;
  var originalTime;
  var isDrawingOnCanvas = false,
    lastCursorPos = {},
    canvasContext;
  var isDraggingVolume = false;
  var isGrabbingVR = false;
  var timeMouseOver, timeMouseOverLine;
  var commentToPop = '',
    commentToPopTime = 0;
  var errorOnHD = false,
    errorOnSD = false;
  var curQuality,
    canDoHD = false,
    canDoSD = false,
    canDoAudio = false;
  var commentInEdit = {
    xPos: 0,
    yPos: 0,
    lat: 0,
    lon: 0,
    vrView: 'none',
    time: 0,
    color: obj.config.commentColor,
    dot: null,
    isDot: false,
    drawingBase64: '',
    drawingPath: '',
    isDrawing: false,
    drawingImg: null,
    progressDot: null,
    isEditing: true
  };

  if (obj.config.isTouch) {
    obj.playerSettings.alwaysShowControls = true;
    obj.playerSettings.quality = 'SD';
  }

  if (
    obj.playerSettings.vrMode == obj.config.VR_MODE_MONOSCOPIC ||
    obj.playerSettings.vrMode == obj.config.VR_MODE_OVERUNDER ||
    obj.playerSettings.vrMode == obj.config.VR_MODE_SIDEBYSIDE
  ) {
    obj.playerSettings.isVR = true;
  } else {
    obj.playerSettings.isVR = false;
    obj.playerSettings.vrMode = obj.config.VR_MODE_NONE;
  }

  this.CanPlayFile = function(ext) {
    var tempVideo = $('<video/>')[0];
    var tempAudio = $('<audio/>')[0];

    if (typeof tempVideo.canPlayType != 'function' && typeof tempAudio.canPlayType != 'function') {
      return false;
    }

    return (
      !!tempVideo.canPlayType('video/' + ext).replace('no', '') ||
      !!tempAudio.canPlayType('audio/' + ext).replace('no', '')
    );
  };

  this.TogglePause = function() {
    if (isPlayingBackward) {
      obj.Pause();
      return false;
    }
    if (videoPlayer) {
      obj.SetSpeed(1);
      if (videoPlayer.paused || videoPlayer.ended) {
        obj.Play();
      } else {
        obj.Pause();
      }
    }
  };
  this.isPaused = function() {
    if (videoPlayer) {
      return videoPlayer.paused || videoPlayer.ended;
    }
  };
  this.Pause = function() {
    clearTimeout(intervalRewind);
    isPlayingBackward = false;
    if (videoPlayer && typeof videoPlayer.pause == 'function') {
      $('.waveplayer_container .playback_play_pause').addClass('paused');
      videoPlayer.pause();
      ShowCommentsAtCurrentTime();
      obj.SetSpeed(1);
    }
  };
  this.Play = function() {
    if (isPlayingBackward) {
      obj.Pause();
    }
    if (videoPlayer && typeof videoPlayer.play == 'function') {
      $('.waveplayer_container .playback_play_pause').removeClass('paused');
      obj.HideComments();
      const playPromise = videoPlayer.play();
      if (playPromise !== null) {
        playPromise.catch(() => {
          $('.waveplayer_container .playback_play_pause').addClass('paused');
        });
      }
    }
  };
  this.PlayWhenReady = function() {
    if (!obj.config.isTouch) {
      if (videoPlayer) {
        if (videoPlayer.readyState > videoPlayer.HAVE_CURRENT_DATA) {
          /* HAVE_CURRENT_DATA == this frame only, so > means it can play a little bit into the future, or the entire thing */
          obj.Play();
        } else {
          videoPlayer.addEventListener('loadeddata', obj.Play);
        }
      } else {
        obj.playerSettings.autostart = true;
      }
    }
  };
  this.ToggleMute = function(mute) {
    if (videoPlayer) {
      if (typeof mute == 'undefined') {
        mute = !videoPlayer.muted;
      }

      videoPlayer.muted = mute;
      UpdateVolumeSlider();
    }
  };
  this.SetVolume = function(newVol) {
    if (videoPlayer) {
      newVol = parseFloat(newVol) || 1;

      if (newVol < 0) {
        newVol = 0;
      }
      if (newVol > 1) {
        newVol = 1;
      }

      videoPlayer.volume = obj.playerSettings.volume = newVol;

      if (obj.playerSettings.volume == 0) {
        obj.ToggleMute(true);
      } else {
        obj.ToggleMute(false);
      }
    }
  };
  var UpdateVolumeSlider = function() {
    if (videoPlayer) {
      $('.waveplayer_container .playback_volume').removeClass('muted low med');
      if (videoPlayer.muted || obj.playerSettings.volume == 0) {
        $('.waveplayer_container .playback_volume').addClass('muted');
        $('.waveplayer .volume_slider').height(0 + '%');
      } else {
        $('.waveplayer .volume_slider').height(obj.playerSettings.volume * 100 + '%');
        if (obj.playerSettings.volume <= 0.33) {
          $('.waveplayer_container .playback_volume').addClass('low');
        } else if (obj.playerSettings.volume <= 0.66) {
          $('.waveplayer_container .playback_volume').addClass('med');
        }
      }
    }
  };
  this.ToggleLoop = function() {
    if (videoPlayer) {
      videoPlayer.loop = !videoPlayer.loop;

      if (videoPlayer.loop) {
        $('.waveplayer_container .playback_loop').addClass('active');
      } else {
        $('.waveplayer_container .playback_loop').removeClass('active');
      }
    }
  };
  this.GoToTime = function(time) {
    clearTimeout(intervalRewind);
    if (typeof ClearCommentBorders == 'function') {
      ClearCommentBorders();
    }
    if (videoPlayer) {
      //obj.Pause();
      time = parseFloat(time) || 0;

      var duration = videoPlayer.duration;

      /*
      var delta = 1 / 30;
      if(obj.playerSettings.framerate > 0){
        delta = 1 / obj.playerSettings.framerate;
      }
      var numWholeFrames = Math.floor(time / delta);
      time = numWholeFrames * delta;
      */

      $('.waveplayer_container .progress_playback, .waveplayer_container .audio_line').addClass('no_animate');

      if (time < 0) {
        $('.waveplayer_container .progress_playback').css('width', 0 + '%');
        videoPlayer.currentTime = 0;
      } else if (time > videoPlayer.duration) {
        $('.waveplayer_container .progress_playback').css('width', 100 + '%');
        videoPlayer.currentTime = videoPlayer.duration;
      } else {
        if (duration > 0) {
          $('.waveplayer_container .progress_playback').css('width', time / duration * 100 + '%');
        }
        videoPlayer.currentTime = time;
      }
      obj.CancelNewComment();
      ClearCommentCanvas();
      if (!commentToPop && obj.isPaused()) {
        ShowCommentsAtCurrentTime();
      }
    }
  };
  this.GoToTimeAndPopComment = function(time, uniqueID, lat, lon, vrView) {
    if (videoPlayer) {
      commentToPop = uniqueID;
      commentToPopTime = time;
      obj.Pause();
      obj.GoToTime(time);

      if (obj.playerSettings.isVR) {
        VRAnimateCamera(lat, lon);
        if (obj.config.curVRView != obj.config.VR_VIEW_FLAT && obj.config.enableVR) {
          /*  needs to stay in FLAT on iOS  */
          SetVRView(vrView, true);
        }
      }
    }
  };

  this.GetCurrentTime = function() {
    if (videoPlayer) {
      /*
      var delta = 1 / 30;
      if(obj.playerSettings.framerate > 0){
        delta = 1 / obj.playerSettings.framerate;
      }
      var numWholeFrames = Math.floor(videoPlayer.currentTime / delta);
      return numWholeFrames * delta;
      */

      return videoPlayer.currentTime;
    }
  };

  this.SpeedUp = function() {
    if (videoPlayer) {
      if (isPlayingBackward) {
        if (obj.playerSettings.playbackSpeed < -1) {
          obj.playerSettings.playbackSpeed = obj.playerSettings.playbackSpeed * 0.5;
        } else {
          obj.Pause();
          obj.ShowMessage("<div class='pause_black'></div>");
        }
        return false;
      }

      if (obj.playerSettings.playbackSpeed < obj.config.maxSpeed) {
        videoPlayer.playbackRate = obj.playerSettings.playbackSpeed = obj.playerSettings.playbackSpeed * 2;
      }
    }
  };
  this.SlowDown = function() {
    if (isPlayingBackward) {
      obj.Pause();
      return false;
    }
    if (videoPlayer) {
      if (obj.playerSettings.playbackSpeed > obj.config.maxSlow) {
        videoPlayer.playbackRate = obj.playerSettings.playbackSpeed = obj.playerSettings.playbackSpeed * 0.5;
      }
    }
  };

  var intervalRewind,
    timeSinceLastRewind,
    intervalLength,
    isPlayingBackward = false;
  this.PlayBackwards = function() {
    if (videoPlayer) {
      $('.waveplayer_container .playback_play_pause').removeClass('paused');
      isPlayingBackward = true;

      if (obj.playerSettings.playbackSpeed >= 0) {
        obj.playerSettings.playbackSpeed = -1;
      } else if (obj.playerSettings.playbackSpeed > obj.config.maxBackwards) {
        obj.playerSettings.playbackSpeed = obj.playerSettings.playbackSpeed * 2;
      }

      /*  if(obj.playerSettings.framerate > 0){
        intervalLength = 1 / obj.playerSettings.framerate * obj.playerSettings.playbackSpeed;
      } else {
        intervalLength = 1 / 30 * obj.playerSettings.playbackSpeed;
      }
      intervalLength = Math.abs(intervalLength) * 1000;*/

      intervalLength = 1 / 30 * 1000;

      videoPlayer.playbackRate = 1.0;

      timeSinceLastRewind = new Date().getTime();
      clearTimeout(intervalRewind);
      obj.GoBackward(); /*
}
},Math.abs(intervalLength)*1000);*/

      /*  clearInterval(intervalRewind);
        timeSinceLastRewind = new Date().getTime();
        intervalRewind = setInterval(function(){
          var curTime = new Date().getTime();
          var timeDiff = (curTime - timeSinceLastRewind) / 1000;
          timeSinceLastRewind = curTime;
  
          if(videoPlayer.currentTime <= 0){
            clearInterval(intervalRewind);
            videoPlayer.pause();
          } else {
            videoPlayer.currentTime += timeDiff * obj.playerSettings.playbackSpeed;  /* playbackSpeed is negative so we need to add it */
    }
  };

  this.GoBackward = function() {
    clearTimeout(intervalRewind);
    if (videoPlayer) {
      intervalRewind = setTimeout(function() {
        var curTime = new Date().getTime();
        var timeDiff = (curTime - timeSinceLastRewind) / 1000;
        timeSinceLastRewind = curTime;

        if (
          videoPlayer.currentTime <= 0 ||
          videoPlayer.currentTime + timeDiff * obj.playerSettings.playbackSpeed <= 0
        ) {
          clearTimeout(intervalRewind);
          videoPlayer.currentTime = 0;
          obj.Pause();
        } else {
          videoPlayer.currentTime +=
            timeDiff * obj.playerSettings.playbackSpeed; /* playbackSpeed is negative so we need to add it */
          obj.GoBackward();
        }
      }, intervalLength);
    }
  };

  this.SetSpeed = function(newSpeed) {
    if (videoPlayer) {
      if (newSpeed < obj.config.maxSpeed && newSpeed > obj.config.maxBackwards) {
        obj.playerSettings.playbackSpeed = parseFloat(newSpeed) || 1;
      } else {
        obj.playerSettings.playbackSpeed = 1;
      }
      videoPlayer.playbackRate = obj.playerSettings.playbackSpeed;
    }
  };

  var systemMessageTimeout;
  this.ShowMessage = function(msg) {
    if (!$('.waveplayer_container').hasClass('audio') || $('.waveplayer_container').hasClass('waveform')) {
      clearTimeout(systemMessageTimeout);
      $('.system_message')
        .removeClass('visible')
        .html(msg)
        .css('left', $('.controls').width() * 0.5 - $('.system_message').outerWidth() * 0.5)
        .addClass('visible');

      systemMessageTimeout = setTimeout(function() {
        $('.system_message').removeClass('visible');
      }, 1000);
    }
  };

  this.ToggleTitleSafe = function(newVal) {
    if (typeof newVal == 'undefined') {
      newVal = !$('.title_safe').is(':visible');
    }

    if (newVal) {
      $('.waveplayer_container .title_safe').show();
      $('.waveplayer_container .playback_title_safe').addClass('active');
      obj.playerSettings.showTitleSafe = true;
    } else {
      $('.waveplayer_container .title_safe').hide();
      $('.waveplayer_container .playback_title_safe').removeClass('active');
      obj.playerSettings.showTitleSafe = false;
    }
  };

  this.ShowComments = function(enable) {
    if (typeof enable == 'undefined') {
      enable = !$('.waveplayer_container').hasClass('enable_comments');
    }

    /*  obj.playerSettings.enableComments = enable; */
    obj.config.commentsVisible = enable;

    if (enable) {
      obj.ShowControls(true);
      $('.waveplayer_container').addClass('enable_comments');
      if (!obj.playerSettings.isVR) {
        $('.waveplayer_container .comment_point').addClass('active');
        $('.waveplayer_container')
          .addClass('cursor_comment_point')
          .removeClass('cursor_comment_paint');
        $('.waveplayer_container .hand_icon')
          .removeClass('active')
          .hide();
      } else {
        $('.waveplayer_container .hand_icon')
          .addClass('active')
          .show();
        $('.waveplayer_container .comment_point, .waveplayer_container .comment_paint').removeClass('active');
        $('.waveplayer_container')
          .removeClass('cursor_comment_point')
          .removeClass('cursor_comment_paint');
      }
      ShowCommentsAtCurrentTime();
    } else {
      obj.ShowControls(obj.playerSettings.alwaysShowControls);

      $('.waveplayer_container .hand_icon')
        .addClass('active')
        .show();
      $('.waveplayer_container .comment_point, .waveplayer_container .comment_paint').removeClass('active');

      $('.waveplayer_container')
        .removeClass('enable_comments')
        .removeClass('cursor_comment_point')
        .removeClass('cursor_comment_paint');
      ClearCommentCanvas();
      obj.CancelNewComment();
    }
    /*$(window).trigger("resize");*/
    obj.HandleResize();
  };

  this.ShowControls = function(show) {
    if (typeof show == 'undefined') {
      show = !$('.waveplayer_container .controls').hasClass('always_visible');
    }

    /*  obj.playerSettings.alwaysShowControls = show; */
    if (show) {
      $('.waveplayer_container .controls').addClass('always_visible');
      $('.waveplayer_container').addClass('controls_always_visible');
    } else {
      /*if(obj.playerSettings.enableComments){
        obj.ShowComments(false);
      }*/
      $('.waveplayer_container')
        .removeClass('enable_comments')
        .removeClass('cursor_comment_point')
        .removeClass('cursor_comment_paint');

      $('.waveplayer_container .controls').removeClass('always_visible');
      $('.waveplayer_container').removeClass('controls_always_visible');
    }
    /*$(window).trigger("resize");*/
    obj.HandleResize();
  };

  this.ToggleFullscreen = function(newVal) {
    var isCurrentlyFullscreen = false;
    if (
      document.fullScreen ||
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement ||
      $('.waveplayer_container').hasClass('fullscreen')
    ) {
      isCurrentlyFullscreen = true;
    }

    if (typeof newVal == 'undefined') {
      if (isCurrentlyFullscreen) {
        newVal = false;
      } else {
        newVal = true;
      }
    }

    if ((newVal && isCurrentlyFullscreen) || (!newVal && !isCurrentlyFullscreen)) {
      return false;
    }

    var wavePlayerDiv = $('.waveplayer .waveplayer_container')[0];
    if (videoPlayer && wavePlayerDiv) {
      if (newVal) {
        if (obj.config.isiOS && !obj.config.isiPad) {
          if (videoPlayer.webkitRequestFullscreen) videoPlayer.webkitRequestFullscreen();
          else if (videoPlayer.webkitEnterFullScreen) videoPlayer.webkitEnterFullScreen();
        } else if (wavePlayerDiv.requestFullScreen) {
          wavePlayerDiv.requestFullScreen();
        } else if (wavePlayerDiv.requestFullscreen) {
          wavePlayerDiv.requestFullscreen();
        } else if (wavePlayerDiv.webkitRequestFullscreen) {
          wavePlayerDiv.webkitRequestFullscreen();
        } else if (wavePlayerDiv.webkitRequestFullScreen) {
          wavePlayerDiv.webkitRequestFullScreen();
        } else if (wavePlayerDiv.mozRequestFullScreen) {
          wavePlayerDiv.mozRequestFullScreen();
        } else if (wavePlayerDiv.msRequestFullscreen) {
          wavePlayerDiv.msRequestFullscreen();
        }

        $('.waveplayer .waveplayer_container').addClass('fullscreen');
        obj.config.isFullscreen = true;
        obj.HandleResize();
        /*if(obj.config.isiOS){
          obj.Play();
        }*/
      } else {
        if (obj.config.isiOS && !obj.config.isiPad) {
          if (videoPlayer.webkitCancelFullScreen) videoPlayer.webkitCancelFullScreen();
          else if (videoPlayer.webkitExitFullscreen) videoPlayer.webkitExitFullscreen();
        } else if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }

        $('.waveplayer .waveplayer_container').removeClass('fullscreen');
        obj.config.isFullscreen = false;
        obj.HandleResize();
        /*if(obj.config.isiOS){
          obj.Pause();
        }*/
      }
    }
  };

  var FullscreenChange = function() {
    if (
      document.fullScreen ||
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    ) {
      obj.config.isFullscreen = true;
    } else {
      obj.config.isFullscreen = false;
      $('.waveplayer .waveplayer_container').removeClass('fullscreen');
      obj.HandleResize();
      setTimeout(function() {
        obj.HandleResize();
        if (typeof ResizeComments == 'function') {
          ResizeComments();
        }
      }, 1000);
    }
  };

  var FullscreenError = function() {
    obj.config.isFullscreen = false;
    $('.waveplayer .waveplayer_container').removeClass('fullscreen');
    obj.ShowMessage('Error going fullscreen');
  };

  var PlaybackError = function() {
    $('.waveplayer .waveplayer_container').addClass('error');
    $('.waveplayer .playback_error')
      .html('<p>' + obj.playerSettings.playbackErrorStr + '</p>')
      .show();
    obj.ShowComments(false);
    obj.ShowControls(false);
    $('.waveplayer .controls, .waveplayer .media').hide();
  };

  var PreloadWavePlayerImages = function() {
    var images = new Array();
    for (var i = 0; i < PreloadWavePlayerImages.arguments.length; i++) {
      images[i] = new Image();
      images[i].src = PreloadWavePlayerImages.arguments[i];
      /*console.log(PreloadWavePlayerImages.arguments[i]);*/
    }
  };

  var MouseMove = function(e) {
    var d = new Date();
    if (isDraggingTimePosition) {
      var progressObj = $('.waveplayer_container .progress_container');
      var pageX = e.pageX;
      if (!pageX && e.originalEvent && e.originalEvent.touches && e.originalEvent.touches.length) {
        pageX = e.originalEvent.touches[0].pageX;
      }
      var xPos = pageX - progressObj.offset().left;
      if (progressObj.width() > 0) {
        if (d.getTime() > timeOfLastDragUpdate + dragUpdateInterval) {
          timeOfLastDragUpdate = d.getTime();
          obj.Pause();
          obj.GoToTime(xPos / progressObj.width() * videoPlayer.duration);
        } else {
          clearTimeout(dragRefreshTimeout);
          dragRefreshTimeout = setTimeout(function() {
            obj.GoToTime(xPos / progressObj.width() * videoPlayer.duration);
          }, dragUpdateInterval);
        }
      }
    }
  };

  var MouseDraw = function(e) {
    var target = $('.waveplayer .interaction_target'); /* .comment_canvas  */
    var canvas = $('.waveplayer .comment_canvas.in_progress');
    var mousePos = GetMousePosition(e);
    var pageX = mousePos.x;
    var pageY = mousePos.y;

    if (canvas.attr('width') <= 0 || canvas.attr('height') <= 0 || target.width() <= 0 || target.height() <= 0) {
      return false;
    }

    var startX = lastCursorPos['x'],
      startY = lastCursorPos['y'],
      endX,
      endY;

    if (
      obj.playerSettings.isVR &&
      obj.config.curVRView != obj.config.VR_VIEW_FLAT &&
      obj.config.curVRView != obj.config.VR_MODE_NONE &&
      obj.config.threeJSObj &&
      obj.config.threeJSObj.camera &&
      obj.config.threeJSObj.scene
    ) {
      var uv = GetUVFromMouse(pageX, pageY);

      endX = uv.u * canvas.attr('width');
      endY = uv.v * canvas.attr('height');
    } else {
      endX = (pageX - target.offset().left) / target.width() * canvas.attr('width');
      endY = (pageY - target.offset().top) / target.height() * canvas.attr('height');
    }

    if (!isDrawingOnCanvas) {
      isDrawingOnCanvas = true;

      /* so a click results in a dot (a line that's 1px long), instead of nothing */
      startX = endX - 1;
      startY = endY - 1;
    }

    /* avoid the rings made by drawing at the canvas edge. if the distance between the points is greater than half of the canvas side (average b/t width and height) then don't draw it */
    if (
      obj.playerSettings.isVR &&
      Math.sqrt((endX - startX) * (endX - startX) + (endY - startY) * (endY - startY)) > 0.25 * canvas.attr('width')
    ) {
      startX = endX - 1;
      startY = endY - 1;
      /* return false; */
      /*
      if(startX < 2) startX = 2;
      if(startX > canvas.attr("width") - 2) startX = canvas.attr("width") - 2;

      if(startY < 2) startY = 2;
      if(startY > canvas.attr("height") - 2) startY = canvas.attr("height") - 2;

      if(endX < 2) endX = 2;
      if(endX > canvas.attr("width") - 2) endX = canvas.attr("width") - 2;

      if(endY < 2) endY = 2;
      if(endY > canvas.attr("height") - 2) endY = canvas.attr("height") - 2;
      */
    }

    /*
    if(startX == endX && startY == endY){
      startX--;
      startY--;
    }*/

    var canvasContext = $('.waveplayer .comment_canvas.in_progress')[0].getContext('2d');

    canvasContext.strokeStyle = obj.config.commentColorOptions[obj.config.commentColor];
    canvasContext.lineJoin = 'round';
    canvasContext.lineWidth = 2;
    canvasContext.beginPath();
    canvasContext.moveTo(startX, startY);
    canvasContext.lineTo(endX, endY);
    canvasContext.stroke();
    canvasContext.closePath();

    lastCursorPos = { x: endX, y: endY };
  };

  this.HandleResize = function() {
    if (obj.config.isFullscreen) {
      $('.waveplayer .waveplayer_container').height('');

      $('.waveplayer .media_comment_holder, .waveplayer .title_safe')
        .width($('.waveplayer .media').width())
        .height($('.waveplayer .media').width() / obj.playerSettings.ratio);
      if ($('.waveplayer .media_comment_holder').height() > $('.waveplayer .media').height()) {
        $('.waveplayer .media_comment_holder, .waveplayer .title_safe').height($('.waveplayer .media').height());
        $('.waveplayer .media_comment_holder, .waveplayer .title_safe').width(
          $('.waveplayer .media').height() * obj.playerSettings.ratio
        );
      }
      $('.waveplayer .media_comment_holder, .waveplayer .title_safe').css({
        'margin-top': ($('.waveplayer .media').height() - $('.waveplayer .media_comment_holder').height()) * 0.5,
        'margin-left': ($('.waveplayer .media').width() - $('.waveplayer .media_comment_holder').width()) * 0.5
      });
    } else if (obj.config.isAudio) {
      $('.waveplayer .waveplayer_container')
        .height('')
        .width('');
      $('.waveplayer .media_comment_holder, .waveplayer .title_safe')
        .width('')
        .height('')
        .css({ 'margin-top': '', 'margin-left': '' });
    } else {
      /*  $(".waveplayer .waveplayer_container").height($(".waveplayer").height());
        $(".waveplayer .waveplayer_container").width($(".waveplayer").width());*/
      var controlsHeight = $('.waveplayer .controls').outerHeight() - $('.waveplayer .controls').height();
      $('.waveplayer .waveplayer_container').width($('.waveplayer').width());
      $('.waveplayer .waveplayer_container').height(
        $('.waveplayer').width() / obj.playerSettings.ratio + controlsHeight
      );
      if ($('.waveplayer .waveplayer_container').height() > $('.waveplayer').height()) {
        $('.waveplayer .waveplayer_container').height($('.waveplayer').height());
        $('.waveplayer .waveplayer_container').width(
          ($('.waveplayer').height() - controlsHeight) * obj.playerSettings.ratio
        );
      }

      /* $(".waveplayer .waveplayer_container").height($(".waveplayer .waveplayer_container").width() / obj.playerSettings.ratio + $(".waveplayer .controls").outerHeight() - $(".waveplayer .controls").height()); */
      $('.waveplayer .media_comment_holder, .waveplayer .title_safe')
        .width('')
        .height('')
        .css({ 'margin-top': '', 'margin-left': '' });
    }

    if (
      obj.playerSettings.isVR &&
      obj.config.threeJSObj.renderer &&
      obj.config.threeJSObj.glCanvas &&
      obj.config.threeJSObj.camera &&
      obj.config.threeJSObj.videocanvas
    ) {
      /*obj.config.threeJSObj.videocanvas.width = obj.config.threeJSObj.glCanvas.parent().width();
      obj.config.threeJSObj.videocanvas.height = obj.config.threeJSObj.glCanvas.parent().height();*/

      /*   obj.config.threeJSObj.renderer.setSize(obj.config.threeJSObj.glCanvas.parent().width(), obj.config.threeJSObj.glCanvas.parent().height()); */
      obj.config.threeJSObj.renderer.setSize(
        $('.waveplayer .media_comment_holder').width(),
        $('.waveplayer .media_comment_holder').height()
      );
      if (obj.config.isFullscreen) {
        obj.config.threeJSObj.glCanvas.css({
          'margin-top': $('.waveplayer .media_comment_holder').css('margin-top'),
          'margin-left': $('.waveplayer .media_comment_holder').css('margin-left')
        });
      } else {
        obj.config.threeJSObj.glCanvas.css({ 'margin-top': '', 'margin-left': '' });
      }

      if ($('.waveplayer .media_comment_holder').height() > 0) {
        /*  obj.config.threeJSObj.glCanvas.parent().height()  */
        /* obj.config.threeJSObj.glCanvas.parent().width() / obj.config.threeJSObj.glCanvas.parent().height(); */
        obj.config.threeJSObj.camera.aspect =
          $('.waveplayer .media_comment_holder').width() / $('.waveplayer .media_comment_holder').height();
      } else {
        obj.config.threeJSObj.camera.aspect = 16 / 9;
      }
      obj.config.threeJSObj.camera.updateProjectionMatrix();

      VRRender();
    }

    $('.system_message').css('left', $('.controls').width() * 0.5 - $('.system_message').outerWidth() * 0.5);
    $('.waveplayer_container .playback_seeking')
      .css('height', $('.waveplayer_container .playback_seeking').width())
      .css(
        'top',
        0.5 *
          $('.waveplayer_container .playback_seeking')
            .parent()
            .height() -
          0.5 * $('.waveplayer_container .playback_seeking').height()
      );

    var i,
      curEl,
      el = [
        '.key_message',
        '.playback_title_safe',
        '.playback_loop',
        '.playback_quality',
        '.vr_view',
        '.timecode .total_time',
        '.timecode',
        '.playback_fullscreen',
        '.playback_volume'
      ];
    for (i = 0; i < el.length; i++) {
      curEl = '.controlbar .control_button' + el[i];
      if (!$(curEl).hasClass('disabled')) {
        $(curEl).show();
      }
    }
    i = 0;
    while (i < el.length && $('.controlbar .button_container').outerWidth(true) > $('.controlbar').outerWidth(true)) {
      curEl = '.controlbar .control_button' + el[i];
      if (!$(curEl).hasClass('disabled')) {
        $(curEl).hide();
      }
      i++;
    }

    if (!$('.comment_controlbar .comment_message').hasClass('disabled')) {
      if ($('.controlbar .control_button.key_message').is(':visible')) {
        $('.comment_controlbar .comment_message').show();
      } else {
        $('.comment_controlbar .comment_message').hide();
      }
    }

    /* $(".waveplayer").css("min-height", $(".waveplayer .waveplayer_container").outerHeight()); */
  };

  this.Destroy = function() {
    if (obj.config.threeJSObj.requestAnimationId) {
      window.cancelAnimationFrame(obj.config.threeJSObj.requestAnimationId);
      obj.config.threeJSObj.requestAnimationId = '';
    }

    if (obj.config.threeJSObj && obj.config.threeJSObj.texture) {
      obj.config.threeJSObj.texture.dispose();
    }
    if (obj.config.threeJSObj && obj.config.threeJSObj.scene) {
      obj.config.threeJSObj.scene.remove(obj.config.threeJSObj.mesh);
    }

    $('.waveplayer video, .waveplayer audio, .waveplayer video source, .waveplayer audio source').off('error');

    $('.waveplayer_container').off('mouseenter mousemove mouseleave contextmenu');

    $('.waveplayer_container .progress_container').off('mouseenter mousemove');
    $('.waveplayer_container .progress_container').off('mousedown touchstart');
    $('.waveplayer .interaction_target, .waveplayer .title_safe').off('mousedown touchstart');
    $(
      '.waveplayer_container .playback_play_pause, .waveplayer_container .playback_volume, .waveplayer_container .playback_loop, .waveplayer_container .playback_title_safe, .waveplayer_container .playback_fullscreen, .waveplayer_container .comment_point, .waveplayer_container .comment_paint, .waveplayer_container .comment_clear_button, .waveplayer_container .hand_icon, .waveplayer_container .comment_color'
    ).off('click');
    $('.waveplayer_container .vr_view, .waveplayer_container .playback_quality').off('click');

    $(
      '.waveplayer_container .playback_volume, .waveplayer_container .vr_view, .waveplayer_container .playback_quality, .waveplayer_container .comment_color'
    ).off('mouseenter mouseleave');
    $(window).off('resize', obj.HandleResize);
    $(window).off('orientationchange', OrientationChangeHandler);

    $(window).off('keydown', KeydownHandler);

    document.removeEventListener('fullscreenchange', FullscreenChange);
    document.removeEventListener('webkitfullscreenchange', FullscreenChange);
    document.removeEventListener('mozfullscreenchange', FullscreenChange);
    document.removeEventListener('MSFullscreenChange', FullscreenChange);

    document.removeEventListener('fullscreenerror', FullscreenError);
    document.removeEventListener('webkitfullscreenerror', FullscreenError);
    document.removeEventListener('mozfullscreenerror', FullscreenError);
    document.removeEventListener('MSFullscreenError', FullscreenError);

    if (videoPlayer) {
      videoPlayer.removeEventListener('loadedmetadata', LoadedMetadataHandler);
      videoPlayer.removeEventListener('loadedmetadata', LoadedMetadataVRFlatHandler);
      videoPlayer.removeEventListener('loadedmetadata', LoadedMetadataVRSphericalHandler);
      videoPlayer.removeEventListener('resize', obj.HandleResize);
      videoPlayer.removeEventListener('loadeddata', obj.Play);
      videoPlayer.removeEventListener('progress', ProgressHandler);
      videoPlayer.removeEventListener('timeupdate', TimeUpdateHandler);
      videoPlayer.removeEventListener('play', PlayHandler);
      videoPlayer.removeEventListener('pause', PauseHandler);
      videoPlayer.removeEventListener('seeking', SeekingHandler);
      videoPlayer.removeEventListener('seeked', SeekedHandler);
      videoPlayer.removeEventListener('volumechange', UpdateVolumeSlider);
      videoPlayer.removeEventListener('stalled', StalledHandler);
      videoPlayer.removeEventListener('ended', EndedHandler);
      videoPlayer.removeEventListener('webkitbeginfullscreen', WebkitBeginFullscreenHandler);
      videoPlayer.removeEventListener('webkitendfullscreen', WebkitEndFullscreenHandler);
    }

    /*  if(obj.config.videoObject){
      obj.config.videoObject.pause();
      obj.config.videoObject.src = '';
      obj.config.videoObject.removeAttribute('src');
    }*/

    obj.config.videoObject = null;
    videoPlayer = null;

    $(
      '.waveplayer_container .media video, .waveplayer_container .media audio'
    ).remove(); /*
}
$(this._renderer.domElement).remove();*/

    /*if(this._isVideo) {
      this.unloadVideo();
      /* unloadVideo is:
        this.pause();
              this._video.src = '';
              this._video.removeAttribute('src');*/
  };

  var UpdateTimecodeDisplay = function(time, duration) {
    $('.waveplayer .controlbar .timecode').html(
      '<p>' +
        ConvertSecondsToSMPTE(time + obj.playerSettings.startTime) +
        "<span class='total_time'> / " +
        ConvertSecondsToSMPTE(duration + obj.playerSettings.startTime) +
        '</span></p>'
    );
  };

  var seekingInterval, seekingTimeout, seekingStartTime, deg;
  var SeekingAnimation = function(enable) {
    if (typeof enable == 'undefined') {
      enable = !$('.waveplayer_container').hasClass('seeking');
    }

    /* clearInterval(seekingInterval);*/
    /* clearTimeout(seekingTimeout); */

    if (enable) {
      if (!obj.config.isSeeking) {
        obj.config.isSeeking = true;

        seekingTimeout = setTimeout(function() {
          if (obj.config.isSeeking) {
            $('.waveplayer_container').addClass('seeking');
            $('.waveplayer_container .playback_seeking')
              .css('height', $('.waveplayer_container .playback_seeking').width())
              .css(
                'top',
                0.5 *
                  $('.waveplayer_container .playback_seeking')
                    .parent()
                    .height() -
                  0.5 * $('.waveplayer_container .playback_seeking').height()
              )
              .show();

            clearInterval(seekingInterval);
            seekingInterval = setInterval(function() {
              seekingStartTime = 0.55 * new Date().getTime();
              deg = parseInt(seekingStartTime - Math.floor(seekingStartTime / 360.0) * 360);

              $('.waveplayer_container .playback_seeking .spinner').css('transform', 'rotate(' + deg + 'deg)');
            }, 30);
          }
        }, 500);
      }

      /*
      if($(".block").length == 0){
        for(var i = 0; i < 4; i++){
          $("<div class='block' />").appendTo($(".waveplayer_container .playback_seeking")).css("left", i * 25 + "%");
        }
      }
      seekingInterval = setInterval(function(){
        var newVal;
        var rad45deg = 0.785398;
        $(".block").each(function(index){
          newVal = Math.cos(new Date / 140 + rad45deg * index * -1) * 33;
          if(newVal < 0){
            newVal = 0;
          }

          $(this).css({"top": 33 - newVal + "%", "bottom": 33 - newVal + "%"});
        });

      }, 30);
      */
    } else {
      obj.config.isSeeking = false;
      clearTimeout(seekingTimeout);
      clearInterval(seekingInterval);

      $('.waveplayer_container').removeClass('seeking');
      $('.waveplayer_container .playback_seeking').hide();
      /*$(".waveplayer_container .playback_seeking .block").remove();*/
    }
  };

  var GetMousePosition = function(e) {
    var pageX = e.pageX;
    var pageY = e.pageY;
    if (!pageX && e.originalEvent && e.originalEvent.touches && e.originalEvent.touches.length) {
      pageX = e.originalEvent.touches[0].pageX;
    }
    if (!pageY && e.originalEvent && e.originalEvent.touches && e.originalEvent.touches.length) {
      pageY = e.originalEvent.touches[0].pageY;
    }

    var coord = { x: pageX, y: pageY };
    return coord;
  };

  var GetUVFromMouse = function(x, y) {
    var returnUV = {};

    var target = $('.waveplayer .interaction_target');

    var raycaster = new THREE.Raycaster();
    var mouse = new THREE.Vector2();
    var onClickPosition = new THREE.Vector2();

    var array = [(x - target.offset().left) / target.width(), (y - target.offset().top) / target.height()];
    onClickPosition.fromArray(array);

    mouse.set(onClickPosition.x * 2 - 1, -(onClickPosition.y * 2) + 1);

    raycaster.setFromCamera(mouse, obj.config.threeJSObj.camera);
    /* var intersects = raycaster.intersectObjects( obj.config.threeJSObj.scene.children ); */
    var intersects = raycaster.intersectObject(obj.config.threeJSObj.mesh);

    /*
    var radius = 500;
    var sphere = {
      position: {
        x: 0,
        y: 0,
        z: 0
      }
    };
    var p = intersects[0].point;
    var x = (p.x - sphere.position.x) / (-1 * radius);
    var y = (p.y - sphere.position.y) / radius;
    var z = (p.z - sphere.position.z) / radius;

    var u = 1 - (Math.atan2(z, x) / (2 * Math.PI) + 0.5);
    var v = 1 - ((Math.asin(y) / Math.PI) + 0.5);
    //console.log("u,v:", u, v);
    endX = u * target.attr("width");
    endY = v * target.attr("height");

    //console.log("endX, endY:", endX, endY);
*/

    if (intersects.length > 0 && intersects[0].uv) {
      var uv = intersects[0].uv;
      /*intersects[ 0 ].object.material.map.transformUv( uv );  /* accounts for flip, repeat, and offset settings. they don't apply here */
      //canvas.setCrossPosition( uv.x, uv.y );*/

      if (obj.config.threeJSObj.texture) {
        uv.x = uv.x * obj.config.threeJSObj.texture.repeat.x + obj.config.threeJSObj.texture.offset.x;
        uv.y = uv.y * obj.config.threeJSObj.texture.repeat.y + obj.config.threeJSObj.texture.offset.y;
      }

      returnUV = { u: 1 - uv.x, v: 1 - uv.y };
    } else {
      returnUV = { u: -1, v: -1 };
    }

    return returnUV;
  };

  var DetectWebGLContext = function() {
    /*return false;*/

    try {
      var canvas = document.createElement('canvas');
      return !!(
        window.WebGLRenderingContext &&
        (canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
      );

      /* var gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");

      if (gl && gl instanceof WebGLRenderingContext) {
        return true;
      } else {
        return false;
      }*/
    } catch (e) {
      return null;
    }
  };

  var VRSetup = function() {
    obj.config.threeJSObj.glCanvas = $('.waveplayer .vr_render_canvas');
    obj.config.threeJSObj.glCanvas.show();
    $('.waveplayer .waveplayer_container').addClass('is_vr');

    /* obj.config.threeJSObj.time = new Date().getTime(); */
    obj.config.threeJSObj.requestAnimationId = '';
    obj.config.threeJSObj.dragStart = {};

    if (isNaN(obj.config.threeJSObj.lat)) {
      obj.config.threeJSObj.lat = 0;
    }
    if (isNaN(obj.config.threeJSObj.lon)) {
      obj.config.threeJSObj.lon = 0;
    }

    obj.config.threeJSObj.fov = obj.config.fov;

    obj.config.threeJSObj.scene = new THREE.Scene();
    obj.config.threeJSObj.camera = new THREE.PerspectiveCamera(
      obj.config.fov,
      obj.config.threeJSObj.glCanvas.parent().width() / obj.config.threeJSObj.glCanvas.parent().height(),
      0.1,
      1000
    );
    /*threeJSObj.camera.setFocalLength(fov);*/

    /*obj.config.threeJSObj.renderer = new THREE.WebGLRenderer();*/
    obj.config.threeJSObj.renderer = DetectWebGLContext()
      ? new THREE.WebGLRenderer({ canvas: obj.config.threeJSObj.glCanvas[0] })
      : new THREE.CanvasRenderer({ canvas: obj.config.threeJSObj.glCanvas[0] });
    //    obj.config.threeJSObj.renderer.setSize( obj.config.vrCanvasWidth, obj.config.vrCanvasHeight, false );
    obj.config.threeJSObj.renderer.setSize(
      obj.config.threeJSObj.glCanvas.parent().width(),
      obj.config.threeJSObj.glCanvas.parent().height()
    );
    /*obj.config.threeJSObj.renderer.setSize( obj.config.threeJSObj.glCanvas.width(), obj.config.threeJSObj.glCanvas.height() ); */
    obj.config.threeJSObj.renderer.autoClear = false;
    obj.config.threeJSObj.renderer.setClearColor(0x333333, 1);

    /*document.body.appendChild(obj.config.threeJSObj.renderer.domElement);*/

    obj.config.threeJSObj.videocanvas = document.createElement('canvas');
    obj.config.threeJSObj.videocanvas.width = obj.playerSettings.width; /* obj.config.threeJSObj.glCanvas.width(); */
    obj.config.threeJSObj.videocanvas.height = obj.playerSettings.height; /* obj.config.threeJSObj.glCanvas.height(); */

    obj.config.threeJSObj.texture = new THREE.Texture(obj.config.threeJSObj.videocanvas, THREE.UVMapping);
    obj.config.threeJSObj.texture.offset.set(0, 0);
    obj.config.threeJSObj.texture.repeat.set(1, 1);

    obj.config.threeJSObj.videoCanvasContext = obj.config.threeJSObj.videocanvas.getContext('2d');
    obj.config.threeJSObj.videoCanvasContext.save();

    obj.config.threeJSObj.videoCanvasContext.scale(-1, 1);
    /* can call obj.config.threeJSObj.videoCanvasContext.restore(); to undo the scale, but we'll never need it */

    /*document.body.appendChild(obj.config.threeJSObj.videocanvas);*/

    obj.config.threeJSObj.texture.generateMipmaps = false;
    obj.config.threeJSObj.texture.minFilter = THREE.LinearFilter;
    obj.config.threeJSObj.texture.magFilter = THREE.LinearFilter;
    obj.config.threeJSObj.texture.format = THREE.RGBFormat;

    /* since our sphere is inside-out, we need to flip the UVs horizontally */
    //    obj.config.threeJSObj.texture.wrapS = THREE.RepeatWrapping;
    //    obj.config.threeJSObj.texture.repeat.x = - 1;

    /* create ThreeJS mesh sphere onto which our texture will be drawn  */
    /* SphereGeometry(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength)  */
    obj.config.threeJSObj.mesh = new THREE.Mesh(
      new THREE.SphereGeometry(500, 40, 25),
      new THREE.MeshBasicMaterial({ map: obj.config.threeJSObj.texture, side: THREE.BackSide })
    ); /* mirror the texture, since we're looking from the inside out */
    /*  obj.config.threeJSObj.mesh.scale.x = -1; */ obj.config.threeJSObj.scene.add(obj.config.threeJSObj.mesh);

    //    var geometry = new THREE.BoxGeometry( 100, 100, 100 );
    //    var material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
    //    var cube = new THREE.Mesh( geometry, material); //movieMaterial );
    //    obj.config.threeJSObj.scene.add( cube );
  };

  var VRAnimateCamera = function(lat, lon) {
    obj.config.threeJSObj.animatingCamera = true;
    obj.config.threeJSObj.startLat = obj.config.threeJSObj.lat;
    obj.config.threeJSObj.startLon = obj.config.threeJSObj.lon;
    obj.config.threeJSObj.targetLat = lat;
    obj.config.threeJSObj.targetLon = lon;
    obj.config.threeJSObj.startTime = new Date().getTime();

    var distanceForMaxAnimLength = 90;
    var xdistance = obj.config.threeJSObj.targetLat - obj.config.threeJSObj.startLat;
    var yDistance = obj.config.threeJSObj.targetLon - obj.config.threeJSObj.startLon;
    var distanceToTarget = Math.sqrt(Math.pow(xdistance, 2) + Math.pow(yDistance, 2));

    var animPercent = distanceToTarget / distanceForMaxAnimLength;
    if (animPercent < 0) animPercent = 0;
    if (animPercent > 1) animPercent = 1;

    obj.config.threeJSObj.endTime = obj.config.threeJSObj.startTime + obj.config.vrCameraAnimationLength * animPercent;
  };

  var VRAnimate = function() {
    if (obj.config.threeJSObj.animatingCamera) {
      if (obj.config.threeJSObj.endTime - obj.config.threeJSObj.startTime > 0) {
        var curTime = new Date().getTime();
        var percentComplete =
          (curTime - obj.config.threeJSObj.startTime) /
          (obj.config.threeJSObj.endTime - obj.config.threeJSObj.startTime);

        percentComplete = EaseOutQuad(percentComplete);

        if (percentComplete >= 1) {
          obj.config.threeJSObj.animatingCamera = false;
          obj.config.threeJSObj.lat = obj.config.curLat = obj.config.threeJSObj.targetLat;
          obj.config.threeJSObj.lon = obj.config.curLon = obj.config.threeJSObj.targetLon;
        } else {
          obj.config.threeJSObj.lat =
            obj.config.threeJSObj.startLat +
            (obj.config.threeJSObj.targetLat - obj.config.threeJSObj.startLat) * percentComplete;
          obj.config.threeJSObj.lon =
            obj.config.threeJSObj.startLon +
            (obj.config.threeJSObj.targetLon - obj.config.threeJSObj.startLon) * percentComplete;
        }
      } else {
        obj.config.threeJSObj.animatingCamera = false;
        obj.config.threeJSObj.lat = obj.config.curLat = obj.config.threeJSObj.targetLat;
        obj.config.threeJSObj.lon = obj.config.curLon = obj.config.threeJSObj.targetLon;
      }
    }

    /* clear the old requested animation frame, then set our animate function to fire next time a frame is ready */
    if (obj.config.threeJSObj.requestAnimationId) {
      window.cancelAnimationFrame(obj.config.threeJSObj.requestAnimationId);
    }
    obj.config.threeJSObj.requestAnimationId = requestAnimationFrame(VRAnimate);
    VRRender();
  };

  var VRRender = function() {
    obj.config.threeJSObj.lat = Math.max(-85, Math.min(85, obj.config.threeJSObj.lat));
    obj.config.threeJSObj.phi = (90 - obj.config.threeJSObj.lat) * Math.PI / 180;
    obj.config.threeJSObj.theta = obj.config.threeJSObj.lon * Math.PI / 180;

    var cx = 500 * Math.sin(obj.config.threeJSObj.phi) * Math.cos(obj.config.threeJSObj.theta);
    var cy = 500 * Math.cos(obj.config.threeJSObj.phi);
    var cz = 500 * Math.sin(obj.config.threeJSObj.phi) * Math.sin(obj.config.threeJSObj.theta);

    obj.config.threeJSObj.camera.lookAt(new THREE.Vector3(cx, cy, cz));

    /*  distortion */
    if (obj.config.flatProjection) {
      obj.config.threeJSObj.camera.position.x = 0;
      obj.config.threeJSObj.camera.position.y = 0;
      obj.config.threeJSObj.camera.position.z = 0;
    } else {
      obj.config.threeJSObj.camera.position.x = -cx;
      obj.config.threeJSObj.camera.position.y = -cy;
      obj.config.threeJSObj.camera.position.z = -cz;
    }

    /* obj.config.threeJSObj.renderer.clear(); */

    /*  obj.config.threeJSObj.videoCanvasContext.translate(obj.config.threeJSObj.videocanvas.width, 0); */
    /*  obj.config.threeJSObj.videoCanvasContext.scale(-1, 1); */

    /*   Readystates are:
      HAVE_NOTHING    0  No information is available about the media resource.
      HAVE_METADATA    1  Enough of the media resource has been retrieved that the metadata attributes are initialized. Seeking will no longer raise an exception.
      HAVE_CURRENT_DATA  2  Data is available for the current playback position, but not enough to actually play more than one frame.
      HAVE_FUTURE_DATA  3  Data for the current playback position as well as for at least a little bit of time into the future is available (in other words, at least two frames of video, for example).
      HAVE_ENOUGH_DATA  4  Enough data is available—and the download rate is high enough—that the media can be played through to the end without interruption.
    */

    if (videoPlayer && videoPlayer.readyState > videoPlayer.HAVE_METADATA) {
      /* obj.config.threeJSObj.videoCanvasContext.drawImage(videoPlayer, 0, 0, -obj.config.threeJSObj.videocanvas.width, obj.config.threeJSObj.videocanvas.height); */
      obj.config.threeJSObj.videoCanvasContext.drawImage(
        videoPlayer,
        -obj.config.threeJSObj.videocanvas.width,
        0,
        obj.config.threeJSObj.videocanvas.width,
        obj.config.threeJSObj.videocanvas.height
      );
      if (obj.config.threeJSObj.texture) {
        obj.config.threeJSObj.texture.needsUpdate = true;
      }
    }

    if ($('.waveplayer .comment_canvas.done')[0]) {
      obj.config.threeJSObj.videoCanvasContext.drawImage(
        $('.waveplayer .comment_canvas.done')[0],
        -obj.config.threeJSObj.videocanvas.width,
        0,
        obj.config.threeJSObj.videocanvas.width,
        obj.config.threeJSObj.videocanvas.height
      );
    }
    if ($('.waveplayer .comment_canvas.in_progress')[0]) {
      obj.config.threeJSObj.videoCanvasContext.drawImage(
        $('.waveplayer .comment_canvas.in_progress')[0],
        -obj.config.threeJSObj.videocanvas.width,
        0,
        obj.config.threeJSObj.videocanvas.width,
        obj.config.threeJSObj.videocanvas.height
      );
    }
    obj.config.threeJSObj.renderer.render(obj.config.threeJSObj.scene, obj.config.threeJSObj.camera);

    /*obj.config.threeJSObj.videoCanvasContext.restore();*/
  };

  this.ChangeVRMode = function(newMode) {
    if (
      newMode == obj.config.VR_MODE_MONOSCOPIC ||
      newMode == obj.config.VR_MODE_OVERUNDER ||
      newMode == obj.config.VR_MODE_SIDEBYSIDE
    ) {
      obj.playerSettings.isVR = true;
      obj.playerSettings.vrMode = newMode;

      /* for the SetPlaybackQuality call below, where it reads curVRView */
      if (newMode == obj.config.VR_MODE_MONOSCOPIC) {
        obj.config.curVRView = obj.config.VR_VIEW_SPHERICAL;
      } else {
        obj.config.curVRView = obj.config.VR_VIEW_LEFT_SPHERICAL;
      }

      $('.comment_drawing').hide();

      for (var i = 0; i < obj.config.comments.length; i++) {
        if (obj.config.comments[i]['isDot'] && obj.config.comments[i]['dot']) {
          obj.config.comments[i]['dot'].remove();
        }
      }
    } else {
      obj.playerSettings.isVR = false;
      obj.playerSettings.vrMode = obj.config.VR_MODE_NONE;

      var target = $('.waveplayer .media_comment_holder');
      for (var i = 0; i < obj.config.comments.length; i++) {
        if (obj.config.comments[i]['isDot'] && target.width() > 0 && target.height() > 0) {
          var thisDot = (obj.config.comments[i]['dot'] = $(
            "<div class='comment_dot " + obj.config.comments[i]['uniqueID'] + "' style='display: none;'/>"
          ).appendTo(target));
          thisDot.css({
            left: obj.config.comments[i]['xPos'] * 100 + '%',
            top: obj.config.comments[i]['yPos'] * 100 + '%',
            'background-color': obj.config.comments[i]['color']
          });
        }
      }
    }

    obj.ShowComments(obj.config.commentsVisible);
    obj.SetPlaybackQuality(obj.playerSettings.quality, !obj.isPaused());
  };

  var SetVRView = function(newMode, shouldAnimate) {
    $('.waveplayer_container .vr_playbackmode').removeClass('flat spherical left right disabled');
    $('.waveplayer_container .vr_view_list').html('');

    if (
      obj.playerSettings.vrMode == obj.config.VR_MODE_OVERUNDER ||
      obj.playerSettings.vrMode == obj.config.VR_MODE_SIDEBYSIDE
    ) {
      /*if(newMode == obj.config.VR_VIEW_SPHERICAL){
        newMode = obj.config.VR_VIEW_LEFT_SPHERICAL;
      }*/
      if (newMode != obj.config.VR_VIEW_LEFT_SPHERICAL && newMode != obj.config.VR_VIEW_RIGHT_SPHERICAL) {
        newMode = obj.config.VR_VIEW_FLAT;
      }
    } else if (obj.playerSettings.vrMode == obj.config.VR_MODE_MONOSCOPIC) {
      /*if(newMode == obj.config.VR_VIEW_LEFT_SPHERICAL || newMode == obj.config.VR_VIEW_RIGHT_SPHERICAL){
        newMode = obj.config.VR_VIEW_SPHERICAL;
      }*/
      if (newMode != obj.config.VR_VIEW_SPHERICAL) {
        newMode = obj.config.VR_VIEW_FLAT;
      }
    } else {
      newMode = obj.config.VR_VIEW_FLAT;
    }

    if (
      newMode == obj.config.VR_VIEW_SPHERICAL ||
      newMode == obj.config.VR_VIEW_LEFT_SPHERICAL ||
      newMode == obj.config.VR_VIEW_RIGHT_SPHERICAL
    ) {
      obj.config.curVRView = newMode;

      if (obj.config.threeJSObj && obj.config.threeJSObj.texture) {
        if (obj.playerSettings.vrMode == obj.config.VR_MODE_OVERUNDER) {
          obj.config.threeJSObj.texture.repeat.set(1, 0.5);
        } else if (obj.playerSettings.vrMode == obj.config.VR_MODE_SIDEBYSIDE) {
          obj.config.threeJSObj.texture.repeat.set(0.5, 1);
        } else {
          obj.config.threeJSObj.texture.repeat.set(1, 1);
        }
      }

      if (newMode == obj.config.VR_VIEW_LEFT_SPHERICAL) {
        if (obj.config.threeJSObj && obj.config.threeJSObj.texture) {
          if (obj.playerSettings.vrMode == obj.config.VR_MODE_OVERUNDER) {
            obj.config.threeJSObj.texture.offset.set(0, 0.5);
          } else {
            obj.config.threeJSObj.texture.offset.set(
              0.5,
              0
            ); /* because canvas is horizontally flipped, this is 0.5,0 instead of 0,0 (because 0.5 x 2 = 1) */
          }
        }

        $('.waveplayer_container .current_vr_view').html("<div class='vr_playbackmode left'></div>");

        $("<li><div class='vr_playbackmode right'></div></li>")
          .appendTo($('.waveplayer_container .vr_view_list'))
          .click(function(e) {
            SetVRView(obj.config.VR_VIEW_RIGHT_SPHERICAL, true);
          });
        $("<li><div class='vr_playbackmode flat'></div></li>")
          .appendTo($('.waveplayer_container .vr_view_list'))
          .click(function(e) {
            SetVRView(obj.config.VR_VIEW_FLAT, true);
          });
        /*$(".waveplayer_container .vr_playbackmode_container.primary .vr_playbackmode").addClass("left");
        $(".waveplayer_container .vr_playbackmode_container.secondary .vr_playbackmode").addClass("right");
        $(".waveplayer_container .vr_playbackmode_container.tertiary").show();
        $(".waveplayer_container .vr_playbackmode_container.tertiary .vr_playbackmode").addClass("flat");*/
      } else if (newMode == obj.config.VR_VIEW_RIGHT_SPHERICAL) {
        if (obj.config.threeJSObj && obj.config.threeJSObj.texture) {
          if (obj.playerSettings.vrMode == obj.config.VR_MODE_OVERUNDER) {
            obj.config.threeJSObj.texture.offset.set(0, 0);
          } else {
            obj.config.threeJSObj.texture.offset.set(
              0,
              0
            ); /* because canvas is horizontally flipped, this is 0,0 instead of 0.5,0 (because 0.5 x 2 = 1)  */
          }
        }

        $('.waveplayer_container .current_vr_view').html("<div class='vr_playbackmode right'></div>");

        $("<li><div class='vr_playbackmode left'></div></li>")
          .appendTo($('.waveplayer_container .vr_view_list'))
          .click(function(e) {
            SetVRView(obj.config.VR_VIEW_LEFT_SPHERICAL, true);
          });
        $("<li><div class='vr_playbackmode flat'></div></li>")
          .appendTo($('.waveplayer_container .vr_view_list'))
          .click(function(e) {
            SetVRView(obj.config.VR_VIEW_FLAT, true);
          });
        /*$(".waveplayer_container .vr_playbackmode_container.primary .vr_playbackmode").addClass("right");
        $(".waveplayer_container .vr_playbackmode_container.secondary .vr_playbackmode").addClass("left");
        $(".waveplayer_container .vr_playbackmode_container.tertiary").show();
        $(".waveplayer_container .vr_playbackmode_container.tertiary .vr_playbackmode").addClass("flat");*/
      } else {
        if (obj.config.threeJSObj && obj.config.threeJSObj.texture) {
          obj.config.threeJSObj.texture.offset.set(0, 0);
        }

        $('.waveplayer_container .current_vr_view').html("<div class='vr_playbackmode spherical'></div>");

        $("<li><div class='vr_playbackmode flat'></div></li>")
          .appendTo($('.waveplayer_container .vr_view_list'))
          .click(function(e) {
            SetVRView(obj.config.VR_VIEW_FLAT, true);
          });
        /*$(".waveplayer_container .vr_playbackmode_container.primary .vr_playbackmode").addClass("spherical");
        $(".waveplayer_container .vr_playbackmode_container.secondary .vr_playbackmode").addClass("flat");
        $(".waveplayer_container .vr_playbackmode_container.tertiary").hide();*/
      }

      $('.waveplayer_container').removeClass('vr_flat');

      $('.waveplayer .vr_render_canvas').show();
      $('.waveplayer .waveplayer_container .comment_canvas').hide();

      obj.playerSettings.ratio = obj.config.vrVideoWidth / obj.config.vrVideoHeight;
      obj.playerSettings.width = obj.config.vrVideoWidth;
      obj.playerSettings.height = obj.config.vrVideoHeight;

      if (shouldAnimate) {
        if (videoPlayer && videoPlayer.videoWidth && videoPlayer.videoHeight) {
          $('.waveplayer .waveplayer_container .media video')
            .hide()
            .css({ width: videoPlayer.videoWidth, height: videoPlayer.videoHeight });
          VRAnimate();
        } else if (videoPlayer) {
          videoPlayer.addEventListener('loadedmetadata', LoadedMetadataVRSphericalHandler);
        }
      }
    } else {
      /* if(newMode == obj.config.VR_VIEW_FLAT){ */

      obj.config.curVRView = obj.config.VR_VIEW_FLAT;

      if (obj.config.threeJSObj && obj.config.threeJSObj.texture) {
        obj.config.threeJSObj.texture.offset.set(0, 0);
      }

      $('.waveplayer_container .current_vr_view').html("<div class='vr_playbackmode flat'></div>");

      if (obj.config.enableVR) {
        if (
          obj.playerSettings.vrMode == obj.config.VR_MODE_SIDEBYSIDE ||
          obj.playerSettings.vrMode == obj.config.VR_MODE_OVERUNDER
        ) {
          $("<li><div class='vr_playbackmode left'></div></li>")
            .appendTo($('.waveplayer_container .vr_view_list'))
            .click(function(e) {
              SetVRView(obj.config.VR_VIEW_LEFT_SPHERICAL, true);
            });
          $("<li><div class='vr_playbackmode right'></div></li>")
            .appendTo($('.waveplayer_container .vr_view_list'))
            .click(function(e) {
              SetVRView(obj.config.VR_VIEW_RIGHT_SPHERICAL, true);
            });
          /*$(".waveplayer_container .vr_playbackmode_container.primary .vr_playbackmode").addClass("flat");
          $(".waveplayer_container .vr_playbackmode_container.secondary .vr_playbackmode").addClass("left");
          $(".waveplayer_container .vr_playbackmode_container.tertiary").show();
          $(".waveplayer_container .vr_playbackmode_container.tertiary .vr_playbackmode").addClass("right");*/
        } else {
          $("<li><div class='vr_playbackmode spherical'></div></li>")
            .appendTo($('.waveplayer_container .vr_view_list'))
            .click(function(e) {
              SetVRView(obj.config.VR_VIEW_SPHERICAL, true);
            });
          /*$(".waveplayer_container .vr_playbackmode_container.primary .vr_playbackmode").addClass("flat");
          $(".waveplayer_container .vr_playbackmode_container.secondary .vr_playbackmode").addClass("spherical");
          $(".waveplayer_container .vr_playbackmode_container.tertiary").hide();*/
        }
      }

      $('.waveplayer_container').addClass('vr_flat');

      if (obj.config.threeJSObj.requestAnimationId && typeof window.cancelAnimationFrame == 'function') {
        window.cancelAnimationFrame(obj.config.threeJSObj.requestAnimationId);
      }

      $('.waveplayer .vr_render_canvas').hide();
      $('.waveplayer .waveplayer_container .media video')
        .show()
        .css({ width: '', height: '' });

      obj.playerSettings.ratio = 16 / 9;
      if (videoPlayer && videoPlayer.videoWidth && videoPlayer.videoHeight) {
        obj.playerSettings.width = videoPlayer.videoWidth;
        obj.playerSettings.height = videoPlayer.videoHeight;

        if (obj.playerSettings.width > 0 && obj.playerSettings.height > 0) {
          obj.playerSettings.ratio = obj.playerSettings.width / obj.playerSettings.height;
        }
      } else {
        videoPlayer.addEventListener('loadedmetadata', LoadedMetadataVRFlatHandler);
      }

      $('.waveplayer .waveplayer_container .comment_canvas').show();
    }

    if ($('.waveplayer_container .vr_view_list').find('li').length > 0) {
      $('.waveplayer_container .vr_view')
        .off('click')
        .on('click', function(e) {
          if ($('.waveplayer_container .vr_view_list_container').is(':visible')) {
            $('.waveplayer_container .vr_view_list_container').hide(obj.config.animationLength);
            $('.waveplayer_container .vr_view_outline').removeClass('active');
          } else {
            $('.waveplayer_container .vr_view_list_container').show(obj.config.animationLength);
            $('.waveplayer_container .vr_view_outline').addClass('active');
          }
        });

      if (!obj.config.isTouch) {
        var vrViewQualityTimeout;

        $('.waveplayer_container .vr_view')
          .off('mouseenter')
          .on('mouseenter', function(e) {
            if (!isDraggingVolume && !isDrawingOnCanvas && !isDraggingTimePosition && !isGrabbingVR) {
              clearTimeout(vrViewQualityTimeout);
              $('.waveplayer_container .vr_view_list_container').show(obj.config.animationLength);
              $('.waveplayer_container .vr_view_outline').addClass('active');

              /* hide playback quality */
              $('.waveplayer_container .playback_quality .playback_quality_list_container').hide(
                obj.config.animationLength
              );
              $('.waveplayer_container .playback_quality .playback_quality_outline').removeClass('active');
            }
          })
          .off('mouseleave')
          .on('mouseleave', function(e) {
            var list = $(this);

            vrViewQualityTimeout = setTimeout(function() {
              list.find('.vr_view_list_container').hide(obj.config.animationLength);
              list.find('.vr_view_outline').removeClass('active');
            }, 750);
          });
      }
    }

    if (!obj.config.enableVR) {
      if (obj.config.isiOS) {
        $('.waveplayer_container .vr_view')
          .off('click')
          .on('click', function(e) {
            obj.ToggleFullscreen(false);
            toast(
              'Unfortunately, iOS does not fully support browser-based 360 video. Please view on desktop or Android for the full experience.'
            );
          });
      } else if (obj.config.isIEMobile) {
        $('.waveplayer_container .vr_view')
          .off('click')
          .on('click', function(e) {
            obj.ToggleFullscreen(false);
            toast(
              'Unfortunately, Windows Phone does not fully support browser-based 360 video. Please view on desktop or Android for the full experience.'
            );
          });
      } else if (obj.config.isIE) {
        $('.waveplayer_container .vr_view')
          .off('click')
          .on('click', function(e) {
            obj.ToggleFullscreen(false);
            toast(
              'Unfortunately, Internet Explorer does not fully support browser-based 360 video. Please view in another browser (such as Chrome) for the full experience.'
            );
          });
      } else {
        $('.waveplayer_container .vr_view')
          .off('click')
          .on('click', function(e) {
            obj.ToggleFullscreen(false);
            toast(
              'Unfortunately, your browser does not fully support 360 video. Please view in another browser (such as Chrome) for the full experience.'
            );
          });
      }
    }

    obj.HandleResize();
  };

  this.SetPlaybackQuality = function(newQuality, autostart) {
    originalTime = 0;
    var shouldLoop = false,
      newVRView = obj.config.VR_VIEW_LEFT_SPHERICAL;
    if (obj.playerSettings.vrMode == obj.config.VR_MODE_MONOSCOPIC) {
      newVRView = obj.config.VR_VIEW_SPHERICAL;
    }
    if (videoPlayer) {
      originalTime = videoPlayer.currentTime;
      shouldLoop = videoPlayer.loop;

      if (obj.config.curVRView != obj.config.VR_MODE_NONE) {
        newVRView = obj.config.curVRView;
      }
    }

    obj.Destroy();

    /* moved to Destroy function
    $('.waveplayer_container .media video, .waveplayer_container .media audio').remove(); */

    if (obj.config.isTouch) {
      $('.waveplayer_container').addClass('is_touch');
      $('.waveplayer .playback_volume')
        .addClass('disabled')
        .hide();
    } else {
      $('.waveplayer_container').removeClass('is_touch');
      $('.waveplayer .playback_volume')
        .removeClass('disabled')
        .show();
    }

    $('.waveplayer_container').addClass('initial_controls');
    setTimeout(function() {
      $('.waveplayer_container').removeClass('initial_controls');
    }, 2000);

    /* key_message.hide(); */

    if (obj.playerSettings.showTitleSafe) {
      obj.ToggleTitleSafe(true);
    } else {
      obj.ToggleTitleSafe(false);
    }

    /*if(obj.config.enableFullscreen){
      $(".waveplayer .playback_fullscreen").removeClass("disabled").show();
    } else {
      $(".waveplayer .playback_fullscreen").addClass("disabled").hide();
    }*/

    var canPlayMP4 = obj.CanPlayFile('mp4'),
      canPlayWEBM = obj.CanPlayFile('webm'),
      canPlayMP3 = obj.CanPlayFile('mp3');
    var isSafari =
      navigator.vendor &&
      navigator.vendor.indexOf('Apple') > -1 &&
      navigator.userAgent &&
      !navigator.userAgent.match('CriOS');
    var playerDiv;

    if (
      (obj.playerSettings.playlist['mp4'] != '' && canPlayMP4) ||
      (obj.playerSettings.playlist['webm'] != '' && canPlayWEBM)
    ) {
      canDoHD = true;
    }
    if (obj.playerSettings.playlist['mobile_mp4'] != '' && canPlayMP4) {
      canDoSD = true;
    }
    if (obj.playerSettings.playlist['mp3'] != '' && canPlayMP3) {
      canDoAudio = true;
    }
    if (newQuality == 'HD' && canDoHD) {
      curQuality = 'HD';
    } else if (newQuality == 'SD' && canDoSD) {
      curQuality = 'SD';
    } else if (newQuality == 'AUDIO' && canDoAudio) {
      curQuality = 'AUDIO';
    } else if (canDoHD) {
      curQuality = 'HD';
    } else if (canDoSD) {
      curQuality = 'SD';
    } else if (canDoAudio) {
      curQuality = 'AUDIO';
    } else {
      PlaybackError();
      return false;
    }

    var autoplayText = '';
    if (!obj.config.isTouch && autostart) {
      autoplayText = 'autoplay';
    }

    if (curQuality == 'HD' || curQuality == 'SD') {
      var playsInlineText =
        'webkit-playsinline playsinline'; /*"";
      if(!obj.config.isiOS){
        playsInlineText = "webkit-playsinline playsinline";
      }*/
      playerDiv = $('<video ' + autoplayText + " x-webkit-airplay='allow' " + playsInlineText + '></video>').appendTo(
        $('.waveplayer_container .media')
      );
      videoPlayer = obj.config.videoObject = $('.waveplayer .waveplayer_container .media video')[0];
      videoPlayer.controls = false;
      obj.config.isAudio = false;
      $('.waveplayer .waveplayer_container').removeClass('audio');
      /*obj.ShowControls(obj.playerSettings.alwaysShowControls);*/

      if (shouldLoop) {
        videoPlayer.loop = true;
      }

      if (obj.playerSettings.isVR) {
        $('.waveplayer_container .comment_canvas')
          .attr('width', obj.config.vrCanvasWidth)
          .attr('height', obj.config.vrCanvasHeight)
          .hide();

        videoPlayer.setAttribute('crossorigin', obj.config.crossOrigin);
        videoPlayer.style.display = 'none';
        /*$(".waveplayer_container .vr_playbackmode_container.primary").show();*/
        $('.waveplayer_container .control_button.vr_view')
          .removeClass('disabled')
          .show();
        $('.waveplayer_container .control_button.playback_title_safe, .waveplayer .title_safe')
          .addClass('disabled')
          .hide();

        /*videoPlayer.addEventListener("loadedmetadata", function () {
          if(videoPlayer && videoPlayer.videoWidth && videoPlayer.videoHeight){
            $(".waveplayer .waveplayer_container .media video").hide().css({"width": videoPlayer.videoWidth, "height": videoPlayer.videoHeight});
          }

          SetCurrentVRMode(obj.playerSettings.vrMode, false);
          VRAnimate();
        });*/

        if (!obj.config.enableVR) {
          SetVRView(obj.config.VR_VIEW_FLAT, false);
        } else {
          VRSetup();
          SetVRView(newVRView, true);

          /*if(obj.playerSettings.vrMode == obj.config.VR_MODE_MONOSCOPIC){
            SetVRView(obj.config.VR_VIEW_SPHERICAL, true);
          } else {
            SetVRView(obj.config.VR_VIEW_LEFT_SPHERICAL, true);
          }*/
        }
      } else {
        $('.waveplayer_container .comment_canvas')
          .attr('height', obj.config.videoCanvasHeight)
          .show();
        $('.waveplayer .vr_render_canvas').hide();
        /*$(".waveplayer_container .vr_playbackmode_container").hide();*/
        $('.waveplayer .waveplayer_container').removeClass('is_vr');
        $('.waveplayer_container .control_button.vr_view')
          .addClass('disabled')
          .hide();
        $('.waveplayer_container .control_button.playback_title_safe, .waveplayer .title_safe').removeClass('disabled');
        $('.waveplayer_container .control_button.playback_title_safe').show();
      }
    } else if (curQuality == 'AUDIO') {
      playerDiv = $('<audio ' + autoplayText + " x-webkit-airplay='allow' " + playsInlineText + '></audio>').appendTo(
        $('.waveplayer_container .media')
      );
      videoPlayer = obj.config.videoObject = $('.waveplayer .waveplayer_container .media audio')[0];
      videoPlayer.controls = false;
      obj.config.isAudio = true;
      $('.waveplayer .waveplayer_container').addClass('audio');
      obj.playerSettings.alwaysShowControls = true;
      obj.ShowControls(true);

      if (shouldLoop) {
        videoPlayer.loop = true;
      }

      /*$('.waveplayer_container .controls').addClass('always_visible');
      $(".waveplayer_container").addClass("controls_always_visible");*/

      $('.waveplayer .playback_title_safe, .waveplayer .title_safe')
        .addClass('disabled')
        .hide();

      $('.waveplayer_container .comment_canvas')
        .attr('height', obj.config.audioCanvasHeight)
        .show();

      if (obj.threeJSObj && obj.threeJSObj.glCanvas) {
        obj.threeJSObj.glCanvas.hide();
      }
    } else {
      if (obj.threeJSObj && obj.threeJSObj.glCanvas) {
        obj.threeJSObj.glCanvas.hide();
      }

      PlaybackError();
      return false;
    }

    if (curQuality == 'HD') {
      /* mp4 listed first for Safari or IE */
      var ieVer = GetIEVersion();
      if (isSafari || (ieVer > 5 && ieVer < 9)) {
        if (obj.playerSettings.playlist['mp4'] != '' && canPlayMP4) {
          playerDiv.append('<source src="' + obj.playerSettings.playlist['mp4'] + '" type="video/mp4">');
        }
        if (obj.playerSettings.playlist['webm'] != '' && canPlayWEBM) {
          playerDiv.append('<source src="' + obj.playerSettings.playlist['webm'] + '" type="video/webm">');
        }
      } else {
        if (obj.playerSettings.playlist['webm'] != '' && canPlayWEBM) {
          playerDiv.append('<source src="' + obj.playerSettings.playlist['webm'] + '" type="video/webm">');
        }
        if (obj.playerSettings.playlist['mp4'] != '' && canPlayMP4) {
          playerDiv.append('<source src="' + obj.playerSettings.playlist['mp4'] + '" type="video/mp4">');
        }
      }
    } else if (curQuality == 'SD') {
      playerDiv.append('<source src="' + obj.playerSettings.playlist['mobile_mp4'] + '" type="video/mp4">');
    } else if (curQuality == 'AUDIO') {
      playerDiv.append('<source src="' + obj.playerSettings.playlist['mp3'] + '" type="audio/mp3">');

      $('.waveplayer .playback_fullscreen')
        .addClass('disabled')
        .hide();

      if (obj.playerSettings.playlist['waveform'] != '') {
        $('.waveplayer_container .media').css({
          'background-image': 'url("' + obj.playerSettings.playlist['waveform'] + '")',
          'background-size': '100% 100%',
          'background-repeat': 'no-repeat'
        });
        $('.waveplayer_container').addClass('waveform');

        /*$(".waveplayer .playback_fullscreen").removeClass("disabled").show();*/
      } else {
        $('.waveplayer_container .media').css('background', '');
        $('.waveplayer_container').removeClass('waveform');
        /* $('.waveplayer_container .controls').addClass('always_visible'); */

        /*$(".waveplayer .playback_fullscreen").addClass("disabled").hide();*/
      }
    } else if (obj.playerSettings.playlist['poster'] != '') {
      playerDiv.append('<img src="' + obj.playerSettings.playlist['poster'] + '" width="100%" height="100%" alt="" />');
    }

    playerDiv.append(
      "<p>To view this video please enable JavaScript, and consider using a browser that supports HTML5 video such as <a href='https://www.google.com/chrome/browser/desktop/index.html' target='_blank'>Chrome</a> or <a href='https://www.mozilla.org/en-US/firefox/products/' target='_blank'>Firefox</a>.</p>"
    );

    if (curQuality == 'HD') {
      $('.waveplayer_container .playback_quality').removeClass('hidden');
      $('.waveplayer_container .current_playback_quality').html('1080p');
      /*  <div class='playback_quality_arrow_container'><div class='playback_quality_arrow'></div></div> */
    } else if (curQuality == 'SD') {
      $('.waveplayer_container .playback_quality').removeClass('hidden');
      $('.waveplayer_container .current_playback_quality').html('&nbsp;540p');
      /* <div class='playback_quality_arrow_container'><div class='playback_quality_arrow'></div></div> */
    } else {
      $('.waveplayer_container .playback_quality')
        .addClass('disabled')
        .hide();
    }

    $('.waveplayer_container .playback_quality_list').html('');
    if (curQuality != 'AUDIO' && canDoSD && canDoHD) {
      if (obj.playerSettings.playlist['mp4'] != '' || obj.playerSettings.playlist['webm'] != '') {
        $('<li>1080p</li>')
          .appendTo($('.waveplayer_container .playback_quality_list'))
          .click(function(e) {
            obj.SetPlaybackQuality('HD', !obj.isPaused());
          });
      }
      if (obj.playerSettings.playlist['mobile_mp4'] != '') {
        $('<li>540p</li>')
          .appendTo($('.waveplayer_container .playback_quality_list'))
          .click(function(e) {
            obj.SetPlaybackQuality('SD', !obj.isPaused());
          });
      }
    } else {
      /*$(".waveplayer_container .playback_quality_arrow_container").remove();*/
      $('.waveplayer_container .playback_quality').unbind('click');
    }

    if ($('.waveplayer_container .playback_quality_list').find('li').length > 0) {
      $('.waveplayer_container .playback_quality')
        .off('click')
        .on('click', function(e) {
          if ($('.waveplayer_container .playback_quality_list_container').is(':visible')) {
            $('.waveplayer_container .playback_quality_list_container').hide(obj.config.animationLength);
            $('.waveplayer_container .playback_quality_outline').removeClass('active');
            /*$(".waveplayer_container .playback_quality_arrow").removeClass("rotated180");*/
          } else {
            $('.waveplayer_container .playback_quality_list_container').show(obj.config.animationLength);
            $('.waveplayer_container .playback_quality_outline').addClass('active');
            /*$(".waveplayer_container .playback_quality_arrow").addClass("rotated180"); */
          }
        });

      if (!obj.config.isTouch) {
        var playbackQualityTimeout;

        $('.waveplayer_container .playback_quality')
          .off('mouseenter')
          .on('mouseenter', function(e) {
            if (!isDraggingVolume && !isDrawingOnCanvas && !isDraggingTimePosition && !isGrabbingVR) {
              clearTimeout(playbackQualityTimeout);
              $('.waveplayer_container .playback_quality_list_container').show(obj.config.animationLength);
              $('.waveplayer_container .playback_quality_outline').addClass('active');

              /* hide VR View Mode */
              $('.waveplayer_container .vr_view .vr_view_list_container').hide(obj.config.animationLength);
              $('.waveplayer_container .vr_view .vr_view_outline').removeClass('active');
            }
          })
          .off('mouseleave')
          .on('mouseleave', function(e) {
            var list = $(this);

            playbackQualityTimeout = setTimeout(function() {
              list.find('.playback_quality_list_container').hide(obj.config.animationLength);
              list.find('.playback_quality_outline').removeClass('active');
              /*$(".waveplayer_container .playback_quality_arrow").removeClass("rotated180");*/
            }, 750);
          });
      }
    }

    videoPlayer.load(); /* must call after setting/changing source */
    videoPlayer.addEventListener('loadedmetadata', LoadedMetadataHandler);
    videoPlayer.addEventListener('resize', obj.HandleResize);
    /*videoPlayer.addEventListener('loadeddata', something);*/
    videoPlayer.addEventListener('progress', ProgressHandler);
    videoPlayer.addEventListener('timeupdate', TimeUpdateHandler);
    videoPlayer.addEventListener('play', PlayHandler);
    videoPlayer.addEventListener('pause', PauseHandler);
    videoPlayer.addEventListener('seeking', SeekingHandler);
    videoPlayer.addEventListener('seeked', SeekedHandler);
    videoPlayer.addEventListener('volumechange', UpdateVolumeSlider);
    videoPlayer.addEventListener('stalled', StalledHandler);
    videoPlayer.addEventListener('ended', EndedHandler);
    videoPlayer.addEventListener('webkitbeginfullscreen', WebkitBeginFullscreenHandler);
    videoPlayer.addEventListener('webkitendfullscreen', WebkitEndFullscreenHandler);

    document.addEventListener('fullscreenchange', FullscreenChange);
    document.addEventListener('webkitfullscreenchange', FullscreenChange);
    document.addEventListener('mozfullscreenchange', FullscreenChange);
    document.addEventListener('MSFullscreenChange', FullscreenChange);

    document.addEventListener('fullscreenerror', FullscreenError);
    document.addEventListener('webkitfullscreenerror', FullscreenError);
    document.addEventListener('mozfullscreenerror', FullscreenError);
    document.addEventListener('MSFullscreenError', FullscreenError);

    SetupClicks();

    $('.waveplayer video, .waveplayer audio, .waveplayer video source, .waveplayer audio source')
      .off('error')
      .on('error', function(e) {
        if (curQuality == 'HD' && canDoSD && !errorOnSD) {
          obj.SetPlaybackQuality('SD', !obj.isPaused());
          errorOnHD = true;
        } else if (curQuality == 'SD' && canDoHD && !errorOnHD) {
          obj.SetPlaybackQuality('HD', !obj.isPaused());
          errorOnSD = true;
        } else {
          PlaybackError();
        }
      });

    $('.waveplayer .title_safe')
      .off('mousedown touchstart')
      .on('mousedown touchstart', function(e) {
        /* needed for browsers that don't support pointer-events: none CSS */
        $('.waveplayer .interaction_target').trigger(e);
      });
    $('.waveplayer .interaction_target')
      .off('mousedown touchstart')
      .on('mousedown touchstart', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (
          obj.playerSettings.isVR &&
          obj.config.curVRView != obj.config.VR_VIEW_FLAT &&
          obj.config.curVRView != obj.config.VR_MODE_NONE &&
          !$('.waveplayer_container .comment_point').hasClass('active') &&
          !$('.waveplayer_container .comment_paint').hasClass('active')
        ) {
          $('.waveplayer_container').addClass('grabbing_vr');
          isGrabbingVR = true;

          var target = $('.waveplayer .interaction_target'); /*  .media_comment_holder  */ /* $(this); */
          var mouse = GetMousePosition(e);

          obj.config.threeJSObj.mouseDown = true;
          obj.config.threeJSObj.dragStart.x = mouse.x;
          obj.config.threeJSObj.dragStart.y = mouse.y;

          $(document)
            .on('mousemove touchmove', function(e) {
              e.preventDefault();
              var mouse = GetMousePosition(e);
              /*obj.config.threeJSObj.onPointerDownPointerX = mouse.x;
          obj.config.threeJSObj.onPointerDownPointerY = -mouse.y;*/

              /* threeJSObj.relativeX = event.pageX - glCanvas.find('canvas').offset().left; */
              /*obj.config.threeJSObj.relativeX = e.pageX - obj.config.threeJSObj.glCanvas.offset().left;*/

              /*obj.config.threeJSObj.onPointerDownLon = obj.config.threeJSObj.lon;
          obj.config.threeJSObj.onPointerDownLat = obj.config.threeJSObj.lat;*/

              var x, y, xMultiplier, yMultiplier;

              if (obj.config.threeJSObj.glCanvas.width() > 0 && obj.config.threeJSObj.glCanvas.height() > 0) {
                /* .find('canvas') */
                xMultiplier = 180 / obj.config.threeJSObj.glCanvas.width(); /* .find('canvas') */
                yMultiplier = 180 / obj.config.threeJSObj.glCanvas.height(); /* .find('canvas') */
              } else {
                xMultiplier = 180 / 1280;
                yMultiplier = 180 / 720;
              }

              var draggingMode = true;
              if (draggingMode) {
                if (obj.config.threeJSObj.mouseDown) {
                  x = mouse.x - obj.config.threeJSObj.dragStart.x;
                  y = mouse.y - obj.config.threeJSObj.dragStart.y;

                  obj.config.threeJSObj.dragStart.x = mouse.x;
                  obj.config.threeJSObj.dragStart.y = mouse.y;

                  obj.config.threeJSObj.lon -= x * xMultiplier;
                  obj.config.threeJSObj.lat += y * yMultiplier;

                  obj.config.curLon = obj.config.threeJSObj.lon;
                  obj.config.curLat = obj.config.threeJSObj.lat;
                }
              } else {
                x = mouse.x - obj.config.threeJSObj.glCanvas.offset().left; /* .find('canvas') */
                y = mouse.y - obj.config.threeJSObj.glCanvas.offset().top; /* .find('canvas') */
                obj.config.threeJSObj.lon =
                  x / obj.config.threeJSObj.glCanvas.width() * 430 - 225; /* .find('canvas') */
                obj.config.threeJSObj.lat =
                  y / obj.config.threeJSObj.glCanvas.height() * -180 + 90; /* .find('canvas') */
              }
            })
            .one('mouseup touchend', function(e) {
              e.preventDefault();
              $('.waveplayer_container').removeClass('grabbing_vr');
              isGrabbingVR = false;
              $(document).off('mousemove touchmove');
              obj.config.threeJSObj.mouseDown = false;
            });
        } else if ($('.waveplayer_container').hasClass('enable_comments') && videoPlayer) {
          $('.waveplayer_container').addClass('making_comment');
          obj.Pause();
          var target = $('.waveplayer .interaction_target'); /*  .media_comment_holder  */ /* $(this); */
          var mouse = GetMousePosition(e);

          if (
            $('.waveplayer_container .comment_point').hasClass('active') &&
            target.width() > 0 &&
            target.height() > 0
          ) {
            $('.waveplayer_container .comment_clear_button').removeClass('disabled');

            var xPos, yPos, uv;

            if (
              obj.playerSettings.isVR &&
              obj.config.curVRView != obj.config.VR_VIEW_FLAT &&
              obj.config.curVRView != obj.config.VR_MODE_NONE
            ) {
              uv = GetUVFromMouse(mouse.x, mouse.y);
              xPos = uv.u;
              yPos = uv.v;
            } else {
              xPos = (mouse.x - target.offset().left) / target.width();
              yPos = (mouse.y - target.offset().top) / target.height();
            }

            if (
              obj.config.isAudio &&
              target.width() > 0 &&
              typeof videoPlayer != 'undefined' &&
              typeof videoPlayer.currentTime != 'undefined' &&
              typeof videoPlayer.duration != 'undefined'
            ) {
              $('.waveplayer .progress_playback, .waveplayer_container .audio_line').addClass('no_animate');
              videoPlayer.currentTime = (mouse.x - target.offset().left) / target.width() * videoPlayer.duration;
              /* GoToTime clears comment canvas
            obj.GoToTime((mouse.x - target.offset().left) / target.width() * videoPlayer.duration); */
            }

            if (xPos < 0) xPos = 0;
            if (xPos > 1) xPos = 1;
            if (yPos < 0) yPos = 0;
            if (yPos > 1) yPos = 1;

            commentInEdit['xPos'] = xPos;
            commentInEdit['yPos'] = yPos;
            commentInEdit['lat'] = obj.config.curLat;
            commentInEdit['lon'] = obj.config.curLon;
            commentInEdit['vrView'] = obj.config.curVRView;
            commentInEdit['time'] = obj.GetCurrentTime(); /* videoPlayer.currentTime; */
            commentInEdit['color'] = obj.config.commentColor;
            commentInEdit['isDot'] = true;
            if (commentInEdit['dot']) {
              commentInEdit['dot'].remove();
            }
            if (!obj.playerSettings.isVR) {
              commentInEdit['dot'] = $("<div class='comment_dot' />").appendTo(target);
            }
            commentInEdit['isDrawing'] = false;
            commentInEdit['drawingBase64'] = '';
            commentInEdit['drawingPath'] = '';
            commentInEdit['drawingImg'] = null;
            commentInEdit['progressDot'] = null;
            commentInEdit['isEditing'] = true;

            if (!obj.playerSettings.isVR) {
              var thisDot = commentInEdit['dot'];
              /* thisDot.css({"left": (xPos - (.5 * $(".comment_dot").outerWidth()) / target.width()) * 100 + "%", "top": (yPos - (.5 * $(".comment_dot").outerHeight()) / target.height()) * 100 + "%", "background-color": obj.config.commentColor}); */
              thisDot.css({
                left: xPos * 100 + '%',
                top: yPos * 100 + '%',
                'background-color': obj.config.commentColorOptions[obj.config.commentColor]
              });
              obj.ShowCommentDot(thisDot, true);
            } else {
              ClearCommentCanvas();
              ShowCommentsAtCurrentTime();
              DrawCommentDot(xPos, yPos, obj.config.commentColorOptions[obj.config.commentColor], false, true);
            }

            $('.waveplayer_container').removeClass('making_comment');

            if (
              !obj.config.isTouch &&
              !obj.config.isFullscreen &&
              typeof obj.playerSettings.commentsClickFallback == 'function'
            ) {
              obj.playerSettings.commentsClickFallback();
            }

            $(document).one('mouseup touchend', function() {
              obj.trigger('shapeDrawn.waveplayer', [obj.GetCommentInEdit(), e]);
            });
          } else if ($('.waveplayer_container .comment_paint').hasClass('active')) {
            /*target = $(".waveplayer .comment_canvas");
          if(target.attr("width") <= 0 || target.attr("height") <= 0){
            return false;
          }

          var widthMult = target.width() / target.attr("width");
          var heightMult = target.height() / target.attr("height");

          if(widthMult <= 0 || heightMult <= 0){
            return false;
          }

          lastCursorPos = {x: (pageX - target.offset().left) / widthMult, y: (pageY - target.offset().top) / heightMult};
          isDrawingOnCanvas = true;*/

            $('.waveplayer_container .comment_clear_button').removeClass('disabled');

            $('.waveplayer_container').addClass('drawing_comment');
            MouseDraw(e);

            $(document)
              .on('mousemove touchmove', function(e) {
                e.preventDefault();
                MouseDraw(e);
              })
              .one('mouseup touchend', function(e) {
                e.preventDefault();
                MouseDraw(e);
                isDrawingOnCanvas = false;
                $('.waveplayer_container').removeClass('drawing_comment');
                $('.waveplayer_container').removeClass('making_comment');
                $(document).off('mousemove touchmove');

                if (
                  obj.config.isAudio &&
                  target.width() > 0 &&
                  typeof videoPlayer != 'undefined' &&
                  typeof videoPlayer.currentTime != 'undefined' &&
                  typeof videoPlayer.duration != 'undefined'
                ) {
                  $('.waveplayer .progress_playback, .waveplayer_container .audio_line').addClass('no_animate');
                  videoPlayer.currentTime = (mouse.x - target.offset().left) / target.width() * videoPlayer.duration;
                  /* GoToTime clears comment canvas
              obj.GoToTime((mouse.x - target.offset().left) / target.width() * videoPlayer.duration); */
                }

                var dataURL = $('.waveplayer .comment_canvas.in_progress')[0].toDataURL('image/png');

                commentInEdit['xPos'] = 0;
                commentInEdit['yPos'] = 0;
                commentInEdit['lat'] = obj.config.curLat;
                commentInEdit['lon'] = obj.config.curLon;
                commentInEdit['vrView'] = obj.config.curVRView;
                commentInEdit['time'] = obj.GetCurrentTime(); /* videoPlayer.currentTime; */
                commentInEdit['color'] = obj.config.commentColor;
                commentInEdit['isDot'] = false;
                if (commentInEdit['dot']) {
                  commentInEdit['dot'].remove();
                }
                commentInEdit['dot'] = null;
                commentInEdit['isDrawing'] = true;
                commentInEdit['drawingBase64'] = dataURL;
                commentInEdit['drawingPath'] = '';
                commentInEdit['drawingImg'] = null;
                commentInEdit['progressDot'] = null;
                commentInEdit['isEditing'] = true;

                if (
                  !obj.config.isTouch &&
                  !obj.config.isFullscreen &&
                  typeof obj.playerSettings.commentsClickFallback == 'function'
                ) {
                  obj.playerSettings.commentsClickFallback();
                }

                obj.trigger('shapeDrawn.waveplayer', [commentInEdit, e]);
              });
          }
        }
      });
  };

  /* event handlers */

  var LoadedMetadataHandler = function() {
    if (!obj.config.isiOS || originalTime > 0.1) {
      /* hack to fix how on old iOS, setting currentTime to 0 broke the property  */
      obj.GoToTime(originalTime);
    }

    obj.playerSettings.duration = videoPlayer.duration;

    if (!obj.playerSettings.isVR) {
      obj.playerSettings.width = videoPlayer.videoWidth;
      obj.playerSettings.height = videoPlayer.videoHeight;

      obj.playerSettings.ratio = 16 / 9;
      if (obj.playerSettings.width > 0 && obj.playerSettings.height > 0) {
        obj.playerSettings.ratio = obj.playerSettings.width / obj.playerSettings.height;
      }
    }

    $('.waveplayer .waveplayer_container .media video').attr('width', '100%');
    $('.waveplayer .waveplayer_container .media video').attr('height', '100%');

    if (obj.config.isFullscreen || obj.config.isAudio) {
      $('.waveplayer .waveplayer_container').height('');
    } else {
      $('.waveplayer .waveplayer_container').height(
        $('.waveplayer .waveplayer_container').width() / obj.playerSettings.ratio
      );
    }

    if (videoPlayer && videoPlayer.duration > 0 && $('.waveplayer .progress_container').width() > 0) {
      var progressPercent, progressDot;

      for (var i = 0; i < obj.config.comments.length; i++) {
        progressDot = obj.config.comments[i]['progressDot'];
        progressPercent = obj.config.comments[i]['time'] / videoPlayer.duration;
        progressDot.css({ display: 'block', left: progressPercent * 100 + '%' });
      }
    }

    UpdateTimecodeDisplay(0, obj.playerSettings.duration);
    obj.HandleResize();
    $(window).on('resize', obj.HandleResize);
    $(window).on('orientationchange', OrientationChangeHandler);

    /* $(".waveplayer").on("widthChange", obj.HandleResize());  */
  };

  var LoadedMetadataVRFlatHandler = function() {
    obj.playerSettings.width = videoPlayer.videoWidth;
    obj.playerSettings.height = videoPlayer.videoHeight;

    if (obj.playerSettings.width > 0 && obj.playerSettings.height > 0) {
      obj.playerSettings.ratio = obj.playerSettings.width / obj.playerSettings.height;
    }
    obj.HandleResize();
  };

  var LoadedMetadataVRSphericalHandler = function() {
    $('.waveplayer .waveplayer_container .media video')
      .hide()
      .css({ width: videoPlayer.videoWidth, height: videoPlayer.videoHeight });
    VRAnimate();
    obj.HandleResize();
  };

  var ProgressHandler = function() {
    if (!isDraggingTimePosition) {
      var range = 0;
      var bf = videoPlayer.buffered;
      var time = videoPlayer.currentTime;
      var duration = videoPlayer.duration;
      var loadStartPercentage = 0,
        loadEndPercentage = 0,
        loadPercentage = 0;

      for (var i = 0; i < bf.length; i++) {
        if (bf.start(i) <= time && time <= bf.end(i)) {
          range = i;
        }
      }

      if (duration > 0 && range < bf.length) {
        loadStartPercentage = bf.start(range) / duration;
        loadEndPercentage = bf.end(range) / duration;
      }

      loadPercentage = loadEndPercentage - loadStartPercentage;
      $('.waveplayer .progress_container .progress_buffered')
        .css('left', loadStartPercentage * 100 + '%')
        .css('width', loadPercentage * 100 + '%');
    }
  };

  var TimeUpdateHandler = function() {
    if ($('.waveplayer_container .playback_seeking').is(':visible')) {
      /* !obj.config.isSeeking &&   */
      SeekingAnimation(false);
      /*$(".waveplayer_container .playback_seeking").hide();*/
    }

    var time = videoPlayer.currentTime;
    var duration = videoPlayer.duration;

    /* for Android, which has duration = 1 until the second timeupdate event */
    if (obj.playerSettings.duration == 1 && duration > 1) {
      obj.playerSettings.duration = duration;
    }

    UpdateTimecodeDisplay(time, duration);
    /* ShowCommentsAtCurrentTime(); */
    if (commentToPop && time == commentToPopTime) {
      ShowCommentsAtCurrentTime();
      obj.PopupCommentDotWithClass(commentToPop);
      obj.PopupCommentImageWithClass(commentToPop);
      commentToPop = '';
      commentToPopTime = 0;
    }

    var playedPercentage = 0;
    if (duration > 0) {
      playedPercentage = time / duration;
    }

    if (obj.config.isAudio) {
      $('.waveplayer_container .audio_line').css('left', playedPercentage * 100 + '%');
    }

    if (!obj.isPaused() && $('.waveplayer .progress_playback').hasClass('no_animate')) {
      $('.waveplayer .progress_playback, .waveplayer_container .audio_line').removeClass('no_animate');
    }
    $('.waveplayer .progress_playback').css('width', playedPercentage * 100 + '%');
  };

  var PlayHandler = function() {
    $('.waveplayer_container .playback_play_pause').removeClass('paused');
    obj.HideComments();
    obj.CancelNewComment();
  };

  var PauseHandler = function() {
    $('.waveplayer_container .playback_play_pause').addClass('paused');
    ShowCommentsAtCurrentTime();
  };

  var SeekingHandler = function() {
    SeekingAnimation(true);
  };

  var SeekedHandler = function() {
    SeekingAnimation(false);
    ShowCommentsAtCurrentTime();
  };

  /* need to test this code. Could result in constantly flipping back and forth */
  var StalledHandler = function() {
    if (!obj.isPaused()) {
      if (curQuality == 'HD' && canDoSD) {
        obj.SetPlaybackQuality('SD', !obj.isPaused());
      } /*else if(curQuality == "SD" && canDoHD){
        obj.SetPlaybackQuality("HD", !obj.isPaused());
      }*/
    }
  };

  var EndedHandler = function() {
    if (!isDraggingTimePosition && obj.playerSettings.pressNextButtonOnEnd === true) {
      $('#wave_linkview_menu_right_arrow').click();
    }
  };

  var WebkitBeginFullscreenHandler = function() {
    obj.ToggleFullscreen(true);
  };

  var WebkitEndFullscreenHandler = function(e) {
    /*if(typeof CustomEvent == 'function' && videoPlayer && videoPlayer.dispatchEvent){
      var event = new CustomEvent("timeupdate", { "detail": "timeupdate" });

      videoPlayer.dispatchEvent(event);
    }*/
    obj.ToggleFullscreen(false);
  };

  var OrientationChangeHandler = function() {
    obj.HandleResize();
    setTimeout(function() {
      obj.HandleResize();
    }, 1000);
  };

  var KeydownHandler = function(e) {
    if (videoPlayer) {
      var foundFocus = false;

      $(document)
        .find('textarea,:text,input')
        .each(function() {
          if ($(this).is(':focus')) {
            foundFocus = true;
          }
        });

      if (!foundFocus) {
        var seekAmount = 1 / 30;
        if (obj.playerSettings.framerate > 0) {
          seekAmount = 1 / obj.playerSettings.framerate;
        }

        if (e.which == 32 || e.which == 75 || e.which == 107) {
          /* space bar or K  or k */
          e.preventDefault();
          obj.TogglePause();
          if (obj.isPaused()) {
            obj.ShowMessage("<div class='pause_black'></div>");
          } else {
            obj.ShowMessage("<div class='play_black'></div>");
          }
        } else if (e.which == 76 || e.which == 108) {
          /* L or l */
          e.preventDefault();
          if (!isPlayingBackward && obj.isPaused()) {
            obj.Play();
            obj.ShowMessage("<div class='play_black'></div>");
          } else {
            if (obj.playerSettings.playbackSpeed != -1) {
              obj.SpeedUp();
              obj.ShowMessage(obj.playerSettings.playbackSpeed + 'x');
            } else {
              obj.SpeedUp();
            }
          }
        } else if (e.which == 74 || e.which == 106) {
          /* J or j */
          e.preventDefault();
          if (obj.isPaused()) {
            obj.PlayBackwards();
            obj.ShowMessage(obj.playerSettings.playbackSpeed + 'x');
          } else {
            obj.SlowDown();
            obj.ShowMessage(obj.playerSettings.playbackSpeed + 'x');
          }
        } else if (e.which == 37) {
          /* left arrow */
          e.preventDefault();
          obj.Pause();
          /* $(".fp-waiting").css("visibility", "hidden"); */
          obj.GoToTime(videoPlayer.currentTime - seekAmount);
          /*obj.GoToTime(obj.GetCurrentTime() - seekAmount); /* rounds down to the closest frame first */
        } else if (e.which == 39) {
          /* right arrow */
          e.preventDefault();
          obj.Pause();
          /* $(".fp-waiting").css("visibility", "hidden"); */
          obj.GoToTime(videoPlayer.currentTime + seekAmount);
          /*obj.GoToTime(obj.GetCurrentTime() + seekAmount); /* rounds down to the closest frame first */
        } else if (e.which == 27) {
          /* escape */
          /*e.preventDefault();*/

          if (obj.config.isFullscreen) {
            setTimeout(function() {
              obj.HandleResize();
            }, 1000);
          }
        } else if (e.which == 80) {
          /* p */
          /*e.preventDefault();*/

          if ($('.waveplayer_container').hasClass('enable_comments')) {
            $('.waveplayer_container .comment_point').click();
          }
        } else if (e.which == 66) {
          /* b */
          /*e.preventDefault();*/

          if ($('.waveplayer_container').hasClass('enable_comments')) {
            $('.waveplayer_container .comment_paint').click();
          }
        } else if (e.which == 72) {
          /* h */
          /*e.preventDefault();*/

          if ($('.waveplayer_container').hasClass('enable_comments')) {
            $('.waveplayer_container .hand_icon').click();
          }
        } else if (e.which == 13) {
          /* Enter */
          e.preventDefault();
          obj.Pause();
          if (
            !obj.config.isTouch &&
            !obj.config.isFullscreen &&
            typeof obj.playerSettings.commentsClickFallback == 'function'
          ) {
            obj.playerSettings.commentsClickFallback();
          }
        }

        /*    } else if(e.which == 38){ /* up arrow */
        /*      e.preventDefault();
    /*      api.volume(Math.min(1, api.volumeLevel + .1));
    /*
    /*    } else if(e.which == 40){ /* down arrow */
        /*      e.preventDefault();
    /*      api.volume(Math.max(0, api.volumeLevel - .1));
    /*
    /*    }
    */
      }
    }
  };

  /* end handlers */

  this.SetCommentFallbackFunction = function(newFunc) {
    if (typeof newFunc == 'function') {
      obj.playerSettings.commentsClickFallback = newFunc;
    }
  };

  this.DeleteComments = function(shouldCancelNewComment) {
    for (var i = 0; i < obj.config.comments.length; i++) {
      if (obj.config.comments[i]['dot']) {
        obj.config.comments[i]['dot'].remove();
      }
      if (obj.config.comments[i]['progressDot']) {
        obj.config.comments[i]['progressDot'].remove();
      }
      if (obj.config.comments[i]['drawingImg']) {
        obj.config.comments[i]['drawingImg'].remove();
      }
    }
    obj.config.comments.length = 0;
    if (shouldCancelNewComment === true) {
      obj.CancelNewComment();
    }
    ClearCommentCanvas(true);
  };

  this.HideCommentDot = function(theDot) {
    theDot.removeClass('visible normal large').hide();
  };
  this.PopupCommentDotWithClass = function(theClass) {
    var theDot = $('.waveplayer_container .media').find($('.comment_dot.' + theClass));
    if (theDot) {
      /*if(videoPlayer && videoPlayer.seeking){
        $(".waveplayer").one("seeked", function(){
          obj.ShowCommentDot(theDot, true);
        });
      } else {*/
      obj.ShowCommentDot(theDot, true);
      /*}*/
    }
  };
  this.PopupCommentImageWithClass = function(theClass) {
    var theImage = $('.waveplayer_container .media').find($('.comment_drawing.' + theClass));
    if (theImage) {
      obj.ShowCommentImage(theImage, true);
    }
  };

  this.ShowCommentDot = function(theDot, shouldAnimate) {
    obj.HideCommentDot(theDot);

    theDot
      .removeClass('visible normal large')
      .show()
      .addClass('visible');

    if (shouldAnimate) {
      theDot.delay(50).queue(function() {
        $(this)
          .addClass('large')
          .dequeue();
        $(this)
          .delay(150)
          .queue(function() {
            $(this)
              .addClass('normal')
              .removeClass('large')
              .dequeue();
          });
      });
    } else {
      theDot.addClass('normal');
    }
  };

  this.ShowCommentImage = function(theImage, shouldAnimate) {
    if (obj.playerSettings.isVR) {
      var canvasObj = $('.waveplayer .comment_canvas.done');
      var canvasContext = canvasObj[0].getContext('2d');
      var img = theImage[0];

      /*var bg = theImage.css('background-image');
      bg = bg.replace('url(','').replace(')','').replace('"','').replace('"','');

      var img = new Image();

      img.crossOrigin = obj.config.crossOrigin;
      img.onload=function(){
        canvasContext.drawImage(img, 0, 0, canvasObj.width(), canvasObj.height());
      }
      img.src = bg;*/

      if (img && img.complete && img.naturalHeight !== 0) {
        canvasContext.drawImage(img, 0, 0, canvasObj.attr('width'), canvasObj.attr('height'));
      } else if (img) {
        img.onload = function() {
          canvasContext.drawImage(img, 0, 0, canvasObj.attr('width'), canvasObj.attr('height'));
        };
      }
    } else {
      theImage
        .addClass('visible')
        .removeClass('bright')
        .show();

      if (shouldAnimate) {
        theImage.delay(50).queue(function() {
          $(this)
            .addClass('bright')
            .dequeue();
          $(this)
            .delay(150)
            .queue(function() {
              $(this)
                .removeClass('bright')
                .dequeue();
            });
        });
      } else {
        theImage.removeClass('bright');
      }
    }
  };

  this.HideComments = function() {
    for (var i = 0; i < obj.config.comments.length; i++) {
      if (obj.config.comments[i]['dot']) {
        obj.HideCommentDot(obj.config.comments[i]['dot']);
      }
      if (obj.config.comments[i]['drawingImg']) {
        obj.config.comments[i]['drawingImg'].removeClass('visible').hide();
      }
      $('#comment_' + obj.config.comments[i]['uniqueID']).css('border-left', 'none');
    }
    ClearCommentCanvas();
    /*if(typeof ClearCommentBorders == 'function'){
      ClearCommentBorders();
    }*/
  };

  var DrawCommentDot = function(xPos, yPos, color, ignoreBorders, in_progress) {
    var canvasObj;
    if (in_progress) {
      canvasObj = $('.waveplayer .comment_canvas.in_progress');
    } else {
      canvasObj = $('.waveplayer .comment_canvas.done');
    }

    var canvasContext = canvasObj[0].getContext('2d');
    var canvasWidth = canvasObj.attr('width'),
      canvasHeight = canvasObj.attr('height');

    if (canvasWidth <= 0 || canvasHeight <= 0) return false;

    var centerX = xPos * canvasObj.attr('width'),
      centerY = yPos * canvasObj.attr('height'),
      radius = 5;

    canvasContext.beginPath();
    canvasContext.arc(centerX, centerY, 1.5 * radius, 0, 2 * Math.PI, false);
    canvasContext.lineWidth = radius;
    canvasContext.strokeStyle = 'rgba(255, 255, 255, 1.0)';
    canvasContext.stroke();

    canvasContext.beginPath();
    canvasContext.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
    canvasContext.fillStyle = color;
    canvasContext.fill();

    if (ignoreBorders !== true) {
      if (centerX < 2 * radius) DrawCommentDot(xPos + 1.0, yPos, color, true, in_progress);
      if (centerX > canvasWidth - 2 * radius) DrawCommentDot(xPos - 1.0, yPos, color, true, in_progress);

      /*if(centerY < 2*radius) DrawCommentDot(xPos, (centerY + canvasHeight)/canvasHeight, color, true, in_progress);
      if(centerY > canvasHeight - 2*radius) DrawCommentDot(xPos, (centerY - canvasHeight)/canvasHeight, color, true, in_progress);*/
    }
  };

  var ClearCommentCanvas = function(keepInProgress) {
    var canvasObj1 = $('.waveplayer .comment_canvas.done');
    var canvasObj2 = $('.waveplayer .comment_canvas.in_progress');
    if (canvasObj1[0] && typeof canvasObj1[0].getContext == 'function') {
      var canvasContext1 = canvasObj1[0].getContext('2d');
      canvasContext1.clearRect(0, 0, canvasObj1.attr('width'), canvasObj1.attr('height'));
    }
    if (keepInProgress !== true) {
      if (canvasObj2[0] && typeof canvasObj2[0].getContext == 'function') {
        var canvasContext2 = canvasObj2[0].getContext('2d');
        canvasContext2.clearRect(0, 0, canvasObj2.attr('width'), canvasObj2.attr('height'));
      }
    }
  };

  var ShowCommentsAtCurrentTime = function() {
    if (videoPlayer) {
      if (obj.isPaused() && obj.config.commentsVisible) {
        /*ClearCommentCanvas();*/
        var curTime = videoPlayer.currentTime;
        var delta = 1 / 30;
        if (obj.playerSettings.framerate > 0) {
          delta = 1 / obj.playerSettings.framerate;
        }
        var scrollToVal, commentDiv, numWholeFrames;
        for (var i = 0; i < obj.config.comments.length; i++) {
          if (!obj.config.comments[i]['isEditing']) {
            numWholeFrames = Math.floor(curTime / delta);
            if (
              numWholeFrames * delta <= obj.config.comments[i]['time'] &&
              obj.config.comments[i]['time'] < (numWholeFrames + 1) * delta
            ) {
              /*  obj.config.comments[i]['time'] >= curTime - 0.5*delta && obj.config.comments[i]['time'] <= curTime + 0.5*delta  */
              if (!obj.playerSettings.isVR && obj.config.comments[i]['dot']) {
                obj.ShowCommentDot(
                  obj.config.comments[i]['dot'],
                  false
                ); /* !$('.waveplayer_container').hasClass("making_comment")); */
              } else if (obj.playerSettings.isVR && obj.config.comments[i]['isDot']) {
                DrawCommentDot(
                  obj.config.comments[i]['xPos'],
                  obj.config.comments[i]['yPos'],
                  obj.config.comments[i]['color'],
                  false,
                  false
                );
              } else if (obj.config.comments[i]['drawingImg']) {
                obj.ShowCommentImage(obj.config.comments[i]['drawingImg'], false);
              }

              $('#comment_' + obj.config.comments[i]['uniqueID']).css(
                'border-left',
                '2px solid ' + obj.config.comments[i]['color']
              );

              /*if($("#comment_" + obj.config.comments[i]['uniqueID']).length){ }*/
            } else {
              if (obj.config.comments[i]['dot']) {
                obj.HideCommentDot(obj.config.comments[i]['dot']);
              }
              if (obj.config.comments[i]['drawingImg']) {
                obj.config.comments[i]['drawingImg'].removeClass('visible').hide();
              }
              $('#comment_' + obj.config.comments[i]['uniqueID']).css('border-left', 'none');
            }
          }
        }
      } else {
        /*obj.HideComments();*/
      }
    }
  };

  this.AddComment = function(uniqueID, xPos, yPos, lat, lon, vrView, time, color, isDot, isDrawing, drawingPath) {
    obj.config.comments.push({
      xPos: xPos,
      yPos: yPos,
      lat: lat,
      lon: lon,
      vrView: vrView,
      time: time,
      color: color,
      dot: null,
      isDot: isDot,
      isDrawing: isDrawing,
      drawingBase64: '',
      drawingPath: drawingPath,
      drawingImg: null,
      progressDot: null,
      isEditing: false,
      uniqueID: uniqueID
    });
    var target = $('.waveplayer .media_comment_holder');
    if (!obj.playerSettings.isVR && isDot && target.width() > 0 && target.height() > 0) {
      var thisDot = (obj.config.comments[obj.config.comments.length - 1]['dot'] = $(
        "<div class='comment_dot " + uniqueID + "' style='display: none;'/>"
      ).appendTo(target));
      /* thisDot.css({"left": (xPos - (.5 * $(".comment_dot").outerWidth()) / target.width()) * 100 + "%", "top": (yPos - (.5 * $(".comment_dot").outerHeight()) / target.height()) * 100 + "%", "background-color": color, "display": "none"});  */
      thisDot.css({ left: xPos * 100 + '%', top: yPos * 100 + '%', 'background-color': color });
    } else if (isDrawing) {
      var thisImg = (obj.config.comments[obj.config.comments.length - 1]['drawingImg'] = $(
        "<img class='comment_drawing " + uniqueID + "' crossorigin='anonymous' style='display: none;'/>"
      ).appendTo(target));
      /* thisImg.css({"background-image": "url('" + drawingPath + "')", "background-size": "100% 100%", "background-repeat": "no-repeat", "display": "none"}); */

      /*thisImg.crossOrigin = obj.config.crossOrigin;  */
      thisImg.attr('src', drawingPath);
      /*thisImg.css("display", "none");*/
    }

    var progressDot = (obj.config.comments[obj.config.comments.length - 1]['progressDot'] = $(
      "<div class='comment_progress_dot " + uniqueID + "' targetCmt='" + uniqueID + "' />"
    ).appendTo($('.waveplayer .progress_container .progress_dot_holder')));
    progressDot.css({ display: 'none', 'background-color': color, left: '0%' });
    progressDot.on('mousedown touchstart', function(e) {
      e.preventDefault();
      e.stopPropagation();
      // $("#comment_" + uniqueID).click();
      let uniqueID = e.target.getAttribute('targetCmt'); //Pick UniqueID of comment Dot element.
      let comment = obj.config.comments.find((cmt) => cmt.uniqueID == uniqueID); //Getting comment from comment Array.
      obj.trigger('timecodeMarkerClick.waveplayer', comment);
    });
    if (!obj.config.isTouch) {
      progressDot
        .on('mousemove', function(e) {
          if (!isDraggingTimePosition) {
            e.stopPropagation();
            e.preventDefault();

            if (!isDraggingVolume && !isDrawingOnCanvas && !isGrabbingVR) {
              var progressObj = $('.waveplayer_container .progress_container');
              if (progressObj.width() > 0) {
                if ($('.time_mouseover').length != 1 || $('.time_mouseover_line').length != 1) {
                  $('.time_mouseover, .time_mouseover_line').remove();
                  $("<div class='time_mouseover' />").appendTo(progressObj);
                  /*$("<div class='time_mouseover_line' />").appendTo(progressDot);*/
                }

                $('.time_mouseover')
                  .html(ConvertSecondsToSMPTE(time + obj.playerSettings.startTime))
                  .css({
                    left: progressDot.position().left - 0.5 * $('.time_mouseover').outerWidth()
                  }); /* , "top": 0 - $(".time_mouseover").outerHeight()}); */
                /*$(".time_mouseover_line").css("left", "50%");*/
              }
              progressObj.addClass('full');
            }
          }
        })
        .on('mouseout', function(e) {
          $('.waveplayer_container .progress_container').removeClass('full');
          $('.time_mouseover, .time_mouseover_line').remove();
        });
    }

    if (videoPlayer && videoPlayer.duration > 0 && $('.waveplayer .progress_container').width() > 0) {
      var progressPercent = time / videoPlayer.duration;
      progressDot.css({ display: 'block', left: progressPercent * 100 + '%' });
    }

    ShowCommentsAtCurrentTime();
  };

  this.GetCommentInEdit = function() {
    if (commentInEdit) {
      return {
        xPos: commentInEdit['xPos'],
        yPos: commentInEdit['yPos'],
        lat: obj.config.curLat /* commentInEdit['lat'], */,
        lon: obj.config.curLon /* commentInEdit['lon'], */,
        vrView: obj.config.curVRView,
        time: commentInEdit['time'],
        color: obj.config.commentColorOptions[commentInEdit['color']],
        dot: null,
        isDot: commentInEdit['isDot'],
        isDrawing: commentInEdit['isDrawing'],
        drawingBase64: commentInEdit['drawingBase64'],
        drawingPath: '',
        drawingImg: null,
        progressDot: null,
        isEditing: false,
        uniqueID: ''
      };
    } else {
      return false;
    }
  };

  this.CommitNewComment = function() {
    if (commentInEdit) {
      obj.config.comments.push(commentInEdit);
      commentInEdit = null;
    }
  };

  this.CancelNewComment = function() {
    /*$(".waveplayer_container").removeClass("cursor_comment_paint").removeClass("cursor_comment_point");
    $(".waveplayer_container .comment_paint").removeClass("active");
    $(".waveplayer_container .comment_point").removeClass("active");*/

    /*var canvasObj = $(".waveplayer .comment_canvas");
    var canvasContext = canvasObj[0].getContext("2d");
    canvasContext.clearRect(0, 0, canvasObj.attr("width"), canvasObj.attr("height"));*/

    if (commentInEdit && commentInEdit['isDot']) {
      if (commentInEdit['dot']) {
        commentInEdit['dot'].remove();
      }
      commentInEdit['dot'] = null;
      commentInEdit['isDot'] = false;
      ClearCommentCanvas();
    } else if (commentInEdit && commentInEdit['isDrawing']) {
      commentInEdit['drawingBase64'] = '';
      commentInEdit['isDrawing'] = false;
      ClearCommentCanvas();
    }

    ShowCommentsAtCurrentTime();

    $('.waveplayer_container .comment_clear_button').addClass('disabled');

    /*if(commentInEdit && commentInEdit['drawingBase64']){
      commentInEdit['drawingBase64'] = "";
    }

    if(commentInEdit && commentInEdit['dot']){
      commentInEdit['dot'].remove();
      commentInEdit['dot'] = null;
    }

    commentInEdit['isDrawing'] = false;
    commentInEdit['isDot'] = false;

    ClearCommentCanvas();
    ShowCommentsAtCurrentTime();
    */
  };

  this.SetFramerate = function(newFPS, newStartTimecode) {
    obj.playerSettings.framerate = parseFloat(newFPS) || 29.97;
    obj.playerSettings.startTime = parseFloat(newStartTimecode) || 0;
  };

  var FormatTime = function(time) {
    time = parseFloat(time);
    var framerate = parseFloat(obj.playerSettings.framerate) || 0;

    var hours = Math.floor(time / 3600);
    var mins = Math.floor((time / 60) % 60);
    var secs = time % 60;
    var frames = secs - Math.floor(secs);
    secs = Math.floor(secs);
    var frames_separator = '.';

    if (framerate > 0 && typeof framerate !== 'undefined') {
      frames = Math.floor(frames * framerate);
      frames_separator = ':';
      frames_text = frames < 10 ? '0' + frames : frames;
    } else {
      frames = frames.toFixed(3);
      frames_text = String(frames).substr(2);
    }

    var minutes = mins < 10 ? '0' + mins : mins;
    var seconds = secs < 10 ? '0' + secs : secs;

    return hours + ':' + minutes + ':' + seconds + frames_separator + frames_text;
  };

  var ConvertSecondsToSMPTE = function(time) {
    var dropframes = 0;
    time = parseFloat(time) || 0;
    var framerate = parseFloat(obj.playerSettings.framerate);

    /* make sure to use "less than" / "greater than" and not "less than or equal to" so that it only checks for decimals and not whole numbers (i.e. 29.97 and not 29 or 30) */

    if (framerate > 29 && framerate < 30) {
      dropframes = 2;
    } else if (framerate > 59 && framerate < 60) {
      dropframes = 4;
    } else {
      dropframes = 0;
    }

    var totalFrames = framerate * time;
    var framesLeft = framerate * time;
    var roundedFramerate = Math.round(framerate);

    if (framerate <= 0 || roundedFramerate <= 0) {
      return FormatTime(time);
    }

    /* figure out the amount of dropframes
       for 29.97 video, it adds 2 frames every minute, except for minutes that are multiples of 10   */

    var totalMinutes = Math.floor(totalFrames / (60 * roundedFramerate));
    var totalDropframes = dropframes * (totalMinutes - Math.floor(totalMinutes / 10));

    var newDropframes = totalDropframes;
    var oldDropframes = 0;
    var dropDiff = 0;
    var foundAll = false;

    while (!foundAll) {
      /* $dropDiff = (amount of dropframes in total + $newDropframes) - (amount of dropframes in total + $oldDropframes); */
      dropDiff =
        dropframes *
          (Math.floor((totalFrames + newDropframes) / (60 * roundedFramerate)) -
            Math.floor(Math.floor((totalFrames + newDropframes) / (60 * roundedFramerate)) / 10)) -
        dropframes *
          (Math.floor((totalFrames + oldDropframes) / (60 * roundedFramerate)) -
            Math.floor(Math.floor((totalFrames + oldDropframes) / (60 * roundedFramerate)) / 10));

      if (dropDiff > 0) {
        oldDropframes = newDropframes;
        newDropframes += dropDiff;
      } else {
        foundAll = true;
      }
    }

    totalDropframes = newDropframes;

    totalFrames += totalDropframes;
    framesLeft += totalDropframes;

    /* After 18 hours, therer are only 2 bonus drop frames added (drop frames created by adding the other drop frames). So let's just not track them
       var bonusDropframes = $dropframes * (($totalDropframes / $roundedFramerate / 60) - floor(($totalDropframes / $roundedFramerate / 60) / 10));    */

    var hours = Math.floor(totalFrames / (60 * 60 * roundedFramerate));
    framesLeft -= hours * (60 * 60 * roundedFramerate);

    var minutes = Math.floor(framesLeft / (60 * roundedFramerate));
    framesLeft -= minutes * (60 * roundedFramerate);

    var seconds = Math.floor(framesLeft / roundedFramerate);
    framesLeft -= seconds * roundedFramerate;

    var frames = Math.floor(framesLeft);

    var sep = ':';
    if (dropframes > 0) {
      sep = ';';
    }

    var hourstext = String(hours) + sep;
    var minutestext = String(minutes) + sep;
    var secondstext = String(seconds) + sep;
    var framestext = String(frames);

    if (hours < 10) {
      hourstext = '0' + hourstext;
    }
    if (hours == 0) {
      hourstext = '';
    }
    if (minutes < 10) {
      minutestext = '0' + minutestext;
    }
    if (seconds < 10) {
      secondstext = '0' + secondstext;
    }
    if (frames < 10) {
      framestext = '0' + framestext;
    }

    return hourstext + minutestext + secondstext + framestext;
  };

  var GetIEVersion = function() {
    var iev = -1;
    var ieold = /MSIE (\d+\.\d+);/.test(navigator.userAgent);
    var trident = !!navigator.userAgent.match(/Trident\/7.0/);
    var rv = navigator.userAgent.indexOf('rv:11.0');

    if (ieold) iev = new Number(RegExp.$1);
    if (navigator.appVersion.indexOf('MSIE 10') != -1) iev = 10;
    if (trident && rv != -1) iev = 11;

    return iev;
  };

  var EaseInQuad = function(t) {
    if (t < 0) t = 0;
    if (t > 1) t = 1;
    return t * t;
  };

  var EaseOutQuad = function(t) {
    if (t < 0) t = 0;
    if (t > 1) t = 1;
    return t * (2 - t);
  };

  var EaseInOutQuad = function(t) {
    if (t < 0) t = 0;
    if (t > 1) t = 1;
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  };

  var EaseInOutCubic = function(t) {
    if (t < 0) t = 0;
    if (t > 1) t = 1;
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  };

  var SetupClicks = function() {
    $('.waveplayer_container')
      .off('mouseenter mousemove')
      .on('mouseenter mousemove', function(e) {
        clearTimeout(mouseOverTimeout);
        $('.waveplayer_container').addClass('mouse_enter');
        if (!$('.waveplayer_container .progress_container').hasClass('full')) {
          mouseOverTimeout = setTimeout(function() {
            if (
              !$('.waveplayer_container .playback_quality_list_container').is(':visible') &&
              !$('.waveplayer_container .playback_volume_control_container').is(':visible')
            ) {
              $('.waveplayer_container').removeClass('mouse_enter');
            }
          }, 2000);
        }
      })
      .off('mouseleave')
      .on('mouseleave', function(e) {
        if (!$('.waveplayer_container .progress_container').hasClass('full')) {
          mouseOverTimeout = setTimeout(function() {
            if (
              !$('.waveplayer_container .playback_quality_list_container').is(':visible') &&
              !$('.waveplayer_container .playback_volume_control_container').is(':visible')
            ) {
              $('.waveplayer_container').removeClass('mouse_enter');
            }
          }, 2000);
        }
      })
      .off('contextmenu')
      .on('contextmenu', function(e) {
        e.preventDefault();

        /*
         var o = root.offset(),
             w = $(window),
             left = ev.clientX - o.left,
             t = ev.clientY - o.top + w.scrollTop();
         var menu = root.find('.fp-context-menu').css({
            left: left + 'px',
            top: t + 'px',
            display: 'block'
         }).on('click', function(ev) {
            ev.stopPropagation();
         });
         $('html').on('click.outsidemenu', function(ev) {
            menu.hide();
            $('html').off('click.outsidemenu');
         });*/
      });

    if (!obj.config.isTouch) {
      $('.waveplayer_container .progress_container')
        .off('mouseenter mousemove')
        .on('mouseenter mousemove', function(e) {
          clearTimeout(progressMouseoverTimeout);
          if (!isDraggingVolume && !isDrawingOnCanvas && !isGrabbingVR) {
            var progressObj = $('.waveplayer_container .progress_container');
            var xPos = e.pageX - progressObj.offset().left;
            if (xPos >= 0 && progressObj.width() > 0) {
              var timePos = xPos / progressObj.width() * videoPlayer.duration;
              if ($('.time_mouseover').length != 1 || $('.time_mouseover_line').length != 1) {
                $('.time_mouseover, .time_mouseover_line').remove();
                $("<div class='time_mouseover' />").appendTo(
                  $('.waveplayer_container .progress_container')
                ); /* .controlbar */
                $("<div class='time_mouseover_line' />").appendTo($('.waveplayer_container .progress_container'));
              }

              $('.time_mouseover')
                .html(ConvertSecondsToSMPTE(timePos + obj.playerSettings.startTime))
                .css(
                  'left',
                  xPos / progressObj.width() * progressObj.width() - 0.5 * $('.time_mouseover').outerWidth()
                ); /* .css("top", progressObj.position().top - $(".time_mouseover").outerHeight()); */
              $('.time_mouseover_line').css('left', xPos / progressObj.width() * progressObj.width());
            }
            progressObj.addClass('full');
          }
        })
        .off('mouseleave')
        .on('mouseleave', function(e) {
          progressMouseoverTimeout = setTimeout(function() {
            $('.waveplayer_container .progress_container').removeClass('full');
            $('.time_mouseover, .time_mouseover_line').remove();
          }, 250);
        });
    }

    $('.waveplayer_container .progress_container')
      .off('mousedown touchstart')
      .on('mousedown touchstart', function(e) {
        e.preventDefault();
        clearTimeout(progressMouseoverTimeout);

        isDraggingTimePosition = true;
        timeOfLastDragUpdate = timeOfDragStart = new Date().getTime();
        $('.waveplayer_container').addClass('dragging_time');
        MouseMove(e);

        $(document)
          .on('mousemove touchmove', function(e) {
            e.preventDefault();
            MouseMove(e);
          })
          .one('mouseup touchend', function(e) {
            e.preventDefault();
            isDraggingTimePosition = false;
            $('.waveplayer_container').removeClass('dragging_time');
            $(document).off('mousemove touchmove');
          });
      });

    $('.waveplayer_container .playback_play_pause')
      .off('click')
      .click(function(e) {
        obj.TogglePause();
      });

    var volumeMouseOutTimeout,
      volumeMouseHasLeft = false;
    $('.waveplayer_container .playback_volume')
      .off('mouseenter')
      .on('mouseenter', function(e) {
        if (isDrawingOnCanvas || isDraggingTimePosition || isGrabbingVR) {
          return;
        }

        $(this).addClass('active');
        clearTimeout(volumeMouseOutTimeout);
        volumeMouseHasLeft = false;

        /* hide playback quality and VR View Mode */
        $('.waveplayer_container .vr_view .vr_view_list_container').hide(obj.config.animationLength);
        $('.waveplayer_container .vr_view .vr_view_outline').removeClass('active');
        $('.waveplayer_container .playback_quality .playback_quality_list_container').hide(obj.config.animationLength);
        $('.waveplayer_container .playback_quality .playback_quality_outline').removeClass('active');

        $('.waveplayer .playback_volume_control_container')
          .show()
          .off('click')
          .click(function(e) {
            e.stopPropagation();
          });

        $('.waveplayer .volume_slider_holder').on('mousedown', function(e) {
          e.stopPropagation();
          isDraggingVolume = true;
          $('.waveplayer_container .media').css('cursor', 'pointer');

          $(document)
            .on('mousemove', function(e) {
              e.stopPropagation();
              if ($('.waveplayer .volume_slider_holder').height() > 0) {
                var pageY = e.pageY;
                var yPos =
                  1 -
                  (pageY - $('.waveplayer .volume_slider_holder').offset().top) /
                    $('.waveplayer .volume_slider_holder').height();
                obj.SetVolume(yPos);
              }
            })
            .one('mouseup', function(e) {
              $(this).off('mousemove');
              isDraggingVolume = false;
              $('.waveplayer_container .media').css('cursor', '');

              if ($('.waveplayer .volume_slider_holder').height() > 0) {
                var pageY = e.pageY;
                var yPos =
                  1 -
                  (pageY - $('.waveplayer .volume_slider_holder').offset().top) /
                    $('.waveplayer .volume_slider_holder').height();
                obj.SetVolume(yPos);
              }
              if (volumeMouseHasLeft) {
                clearTimeout(volumeMouseOutTimeout);
                volumeMouseOutTimeout = setTimeout(function() {
                  $('.waveplayer .volume_slider_holder, .waveplayer .playback_volume_control_container').off('click');
                  $('.waveplayer .playback_volume').removeClass('active');
                  $('.waveplayer .playback_volume_control_container').hide();
                }, 1000);
              }
            });
        });
      })
      .off('mouseleave')
      .on('mouseleave', function(e) {
        volumeMouseHasLeft = true;
        if (!isDraggingVolume) {
          $('.waveplayer .volume_slider_holder, .waveplayer .playback_volume_control_container').off('click');
          $('.waveplayer .playback_volume').removeClass('active');
          $('.waveplayer .playback_volume_control_container').hide();
        }
      });

    $('.waveplayer_container .playback_volume')
      .off('click')
      .click(function(e) {
        if (!isDraggingVolume) {
          obj.ToggleMute();
        }
      });

    $('.waveplayer_container .playback_loop')
      .off('click')
      .click(function(e) {
        obj.ToggleLoop();
      });
    $('.waveplayer_container .playback_title_safe')
      .off('click')
      .click(function(e) {
        obj.ToggleTitleSafe();
      });
    $('.waveplayer_container .playback_fullscreen')
      .off('click')
      .click(function(e) {
        obj.ToggleFullscreen();
      });

    $('.waveplayer_container .comment_point')
      .off('click')
      .click(function(e) {
        /* $(this).toggleClass("active");
      if($(this).hasClass("active")){
        $(".waveplayer_container").addClass("cursor_comment_point");
      } else {
        $(".waveplayer_container").removeClass("cursor_comment_point");
      }*/

        $(this).addClass('active');
        $('.waveplayer_container')
          .addClass('cursor_comment_point')
          .removeClass('cursor_comment_paint');
        $('.waveplayer_container .comment_paint, .waveplayer_container .hand_icon').removeClass('active');

        if (commentInEdit && commentInEdit['isDrawing']) {
          commentInEdit['drawingBase64'] = '';
          commentInEdit['isDrawing'] = false;
          ClearCommentCanvas();
          $('.waveplayer_container .comment_clear_button').addClass('disabled');
        }

        ShowCommentsAtCurrentTime();
      });
    $('.waveplayer_container .comment_paint')
      .off('click')
      .click(function(e) {
        /*$(this).toggleClass("active");
      if($(this).hasClass("active")){
        $(".waveplayer_container").addClass("cursor_comment_paint");
      } else {
        $(".waveplayer_container").removeClass("cursor_comment_paint");
      }*/

        $(this).addClass('active');
        $('.waveplayer_container')
          .addClass('cursor_comment_paint')
          .removeClass('cursor_comment_point');
        $('.waveplayer_container .comment_point, .waveplayer_container .hand_icon').removeClass('active');

        if (commentInEdit && commentInEdit['isDot']) {
          if (commentInEdit['dot']) {
            commentInEdit['dot'].remove();
          }
          commentInEdit['dot'] = null;
          commentInEdit['isDot'] = false;
          ClearCommentCanvas();
          $('.waveplayer_container .comment_clear_button').addClass('disabled');
        }

        ShowCommentsAtCurrentTime();
      });
    $('.waveplayer_container .hand_icon')
      .off('click')
      .click(function(e) {
        $(this).addClass('active');
        $('.waveplayer_container').removeClass('cursor_comment_paint');
        $('.waveplayer_container').removeClass('cursor_comment_point');
        $('.waveplayer_container .comment_point, .waveplayer_container .comment_paint').removeClass('active');
      }); /*
});*/

    /*$(".waveplayer_container .vr_playbackmode_container").off("mouseenter mousemove").on("mouseenter mousemove", function(e){
      $(".waveplayer_container .vr_playbackmode_container").addClass("active");
    }).off("mouseleave").on("mouseleave", function(e){
      $(".waveplayer_container .vr_playbackmode_container").removeClass("active");
    });*/

    /*$(".waveplayer_container .vr_playbackmode_container").off("click").click(function(e){

      e.stopPropagation();
      e.preventDefault();

      if($(this).children().hasClass("flat") && obj.config.curVRView != obj.config.VR_VIEW_FLAT){
        SetVRView(obj.config.VR_VIEW_FLAT, true);
      } else if($(this).children().hasClass("spherical") && obj.config.curVRView != obj.config.VR_VIEW_SPHERICAL){
        SetVRView(obj.config.VR_VIEW_SPHERICAL, true);
      } else if($(this).children().hasClass("left") && obj.config.curVRView != obj.config.VR_VIEW_LEFT_SPHERICAL){
        SetVRView(obj.config.VR_VIEW_LEFT_SPHERICAL, true);
      } else if($(this).children().hasClass("right") && obj.config.curVRView != obj.config.VR_VIEW_RIGHT_SPHERICAL){
        SetVRView(obj.config.VR_VIEW_RIGHT_SPHERICAL, true);
      }

      $(".waveplayer_container .vr_playbackmode_container.secondary, .waveplayer_container .vr_playbackmode_container.tertiary").removeClass("active");
      /*
      if(obj.config.curVRView == obj.config.VR_VIEW_FLAT){
        SetCurrentVRMode(obj.playerSettings.vrMode, true);
      } else {
        SetCurrentVRMode(obj.config.VR_VIEW_FLAT, true);
      }*/ $(
      '.waveplayer_container .comment_clear_button'
    )
      .off('click')
      .click(function(e) {
        if (!$(this).hasClass('disabled')) {
          obj.CancelNewComment();
        }
      });

    $('.waveplayer_container .comment_color')
      .off('click')
      .click(function(e) {
        if ($('.waveplayer_container .comment_color_list_container').is(':visible')) {
          $('.waveplayer_container .comment_color_list_container').hide(obj.config.animationLength);
          $('.waveplayer_container .comment_color_outline').removeClass('active');
        } else {
          $('.waveplayer_container .comment_color_list_container').show(obj.config.animationLength);
          $('.waveplayer_container .comment_color_outline').addClass('active');
        }
      });

    if (!obj.config.isTouch) {
      var commentColorTimeout;

      $('.waveplayer_container .comment_color')
        .off('mouseenter')
        .on('mouseenter', function(e) {
          if (!isDraggingVolume && !isDrawingOnCanvas && !isDraggingTimePosition && !isGrabbingVR) {
            clearTimeout(commentColorTimeout);
            $('.waveplayer_container .comment_color_list_container').show(obj.config.animationLength);
            $('.waveplayer_container .comment_color_outline').addClass('active');
          }
        })
        .off('mouseleave')
        .on('mouseleave', function(e) {
          var list = $(this);

          commentColorTimeout = setTimeout(function() {
            list.find('.comment_color_list_container').hide(obj.config.animationLength);
            list.find('.comment_color_outline').removeClass('active');
          }, 750);
        });

      /*
      $('.waveplayer_container .comment_color').off("mouseleave").on("mouseleave", function() {
        var list = $(this);

        var myTimeout = setTimeout(function () {
          list.find('.comment_color_list_container').hide(obj.config.animationLength);
          list.find('.comment_color_outline').removeClass("active");
        }, 750);

        list.mouseenter(function(){
          clearTimeout(myTimeout);
        });
      });*/
    }

    $(window).on('keydown', KeydownHandler);
  };

  $(document).ready(function() {
    obj
      .addClass('waveplayer')
      .append(
        '\
      <div class="waveplayer_container no_select initial_controls">\
        <div class="playback_error" style="display: none;"></div>\
        <div class="playback_seeking" style="display: none;"><div class="spinner"></div></div>\
        <div class="media">\
          <div class="audio_line"></div>\
          <div class="title_safe" style="display: none;"></div>\
          <div class="media_comment_holder">\
            <div class="interaction_target"></div>\
            <canvas class="comment_canvas in_progress" width="800" height="450"></canvas>\
            <canvas class="comment_canvas done" width="800" height="450"></canvas>\
          </div>\
          <canvas class="vr_render_canvas" style="display: none;"></canvas>\
        </div>\
             <div class="controls">\
          <div class="on_screen_controls">\
          </div>\
          <div class="comment_controlbar">\
            <div class="button_container">\
              <div class="button_container_left">\
                <div class="control_button hand_icon active" title="Select the hand icon to move around in 360 degrees" style="display: none;"></div>\
                <div class="control_button comment_point" title="With this tool, click on the media to leave a point-based comment"></div>\
                <div class="control_button comment_paint" title="With this tool, click and draw on the media to leave a drawing-based comment"></div>\
                <div class="control_button comment_color" title="Choose what color the comment dot or paint should be">\
                  <div class="comment_color_outline">\
                    <div class="current_comment_color"><div class="comment_color_option" style="background-color: ' +
          obj.config.commentColorOptions[obj.config.commentColor] +
          ';"></div></div>\
                    <div class="comment_color_list_container">\
                      <ul class="comment_color_list">\
                      </ul>\
                    </div>\
                  </div>\
                </div>\
                <div class="control_button comment_clear_holder">\
                  <div class="comment_clear_button disabled">Cancel</div>\
                </div>\
              </div>\
              <div class="button_container_middle">\
                <div class="control_button comment_message"></div>\
              </div>\
            </div>\
          </div>\
          <div class="controlbar">\
            <div class="progress_container">\
              <div class="progress_dot_holder"></div>\
              <div class="progress_background"></div>\
              <div class="progress_buffered"></div>\
              <div class="progress_playback"></div>\
            </div>\
            <div class="button_container">\
              <div class="button_container_left">\
                <div class="control_button playback_play_pause paused" title="Play or pause"></div>\
                <div class="control_button timecode"></div>\
              </div>\
              <div class="button_container_middle">\
                <div class="control_button key_message"></div>\
              </div>\
              <div class="button_container_right">\
                <div class="control_button playback_quality" title="Select the playback quality">\
                  <div class="playback_quality_outline">\
                    <div class="playback_quality_list_container">\
                      <ul class="playback_quality_list"></ul>\
                    </div>\
                    <div class="current_playback_quality"></div>\
                  </div>\
                </div>\
                <div class="control_button vr_view" title="Select the VR view">\
                  <div class="vr_view_outline">\
                    <div class="vr_view_list_container">\
                      <ul class="vr_view_list"></ul>\
                    </div>\
                    <div class="current_vr_view"></div>\
                  </div>\
                </div>\
                <div class="control_button playback_title_safe" title="Show or hide title-safe guides"></div>\
                <div class="control_button playback_loop" title="Loop playback"></div>\
                <div class="control_button playback_volume" title="Set volume level, or click to mute">\
                  <div class="playback_volume_control_container" style="display: none;">\
                    <div class="volume_slider_holder"><div class="volume_slider"></div></div>\
                  </div>\
                </div>\
              </div>\
            </div>\
          </div>\
        <div class="system_message"></div>\
        </div>\
      </div>\
          '
      );

    for (var c = 0; c < obj.config.commentColorOptions.length; c++) {
      $('<li class="' + c + '"></li>')
        .appendTo($('.waveplayer_container .comment_color .comment_color_list'))
        .on('click', function(e) {
          obj.config.commentColor = $(this).attr('class'); /*  .split(' ')[1]  */
          $('.waveplayer_container .comment_color .current_comment_color .comment_color_option').css(
            'background-color',
            obj.config.commentColorOptions[obj.config.commentColor]
          );
        })
        .append(
          $(
            '<div class="comment_color_option" style="background-color: ' +
              obj.config.commentColorOptions[c] +
              ';"></div>'
          )
        );
    }

    key_message = $('.waveplayer_container .controls .key_message');
    key_message.html('<p>' + obj.playerSettings.keyMsgStr + '</p>');
    if (obj.config.isTouch) {
      key_message.addClass('disabled').hide();
    }

    $('.waveplayer_container .controls .comment_message').html('<p>' + obj.playerSettings.commentMsgStr + '</p>');

    /* preload volume images */
    /*PreloadWavePlayerImages(
      $(".waveplayer .controls .playback_volume.med").css("background-image"),
      $(".waveplayer .controls .playback_volume.low").css("background-image"),
      $(".waveplayer .controls .playback_volume.muted").css("background-image")
    );*/
    var img1 = new Image(),
      img2 = new Image(),
      img3 = new Image(),
      img4 = new Image();

    const getSrc = (backgroundImageStr) => {
      const arr = backgroundImageStr.split(',');
      arr.pop();
      arr.pop();
      const src = arr
        .join(',')
        .replace(/['"]+/g, '')
        .replace('url(', '')
        .replace(')', '');
      return src;
    };
    img1.src = getSrc(String($('.waveplayer .controls .playback_volume').css('background-image')));

    $('.waveplayer_container .playback_volume').addClass('med');
    img2.src = getSrc(String($('.waveplayer .controls .playback_volume.med').css('background-image')));

    $('.waveplayer_container .playback_volume')
      .removeClass('med')
      .addClass('low');
    img3.src = getSrc(String($('.waveplayer .controls .playback_volume.low').css('background-image')));

    $('.waveplayer_container .playback_volume')
      .removeClass('low')
      .addClass('muted');
    img4.src = getSrc(String($('.waveplayer .controls .playback_volume.muted').css('background-image')));

    $('.waveplayer_container .playback_volume').removeClass('muted');

    /*document.body.appendChild(img1);
    document.body.appendChild(img2);
    document.body.appendChild(img3);*/

    obj.config.isIE = GetIEVersion() > 0 ? true : false;
    obj.config.enableVR =
      !obj.config.isIE &&
      !obj.config.isIEMobile &&
      !obj.config.isiOS &&
      DetectWebGLContext() === true; /* DetectWebGLContext() !== null */

    obj.ShowControls(obj.playerSettings.alwaysShowControls);
    window.ARGS.activeTab == 'ASSETS' || window.ARGS.detail=='true'? null :obj.ShowComments(obj.playerSettings.enableComments) ;
    obj.SetPlaybackQuality(obj.playerSettings.quality, obj.playerSettings.autostart);
    obj.SetVolume(obj.playerSettings.volume);
  });

  return this;
};
